var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDroneStationSpec2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 684,
    height: 323,
    viewBox: "0 0 684 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6840_15889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.51 11.0509H589.595L586.972 8.4248H396.133L393.51 11.0509Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.835 26.6992H431.727",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.725 26.6992H431.617",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.618 26.6992H431.51",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.511 26.6992H431.402",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.942 18.7129H431.834",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.835 18.7129H431.727",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.725 18.7129H431.617",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.618 18.7129H431.51",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.942 26.6992H431.834",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.511 18.7129H431.402",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.512 18.9561V18.9831V19.0102V19.0643V19.0914V19.1456V19.2268V19.2809",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.512 19.2812V26.1308",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.296 26.6719H431.943",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.512 26.1309V26.2121V26.2662V26.3204V26.3745V26.4016V26.4287V26.4557",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.295 26.6726C433.295 26.6726 433.511 26.5914 433.511 26.4561",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.512 18.9023V18.9574",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.296 18.6855H431.943",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.511 18.9021C433.511 18.9021 433.43 18.6855 433.295 18.6855",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.184 18.7129H431.13H431.076",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.283 18.7129H417.337H417.391",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.391 26.6455H417.337H417.283",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.076 26.6455H431.13H431.184",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.391 13.2705H417.337H417.283",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.391 16.6823L417.337 16.6553H417.283",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.402 18.7129H431.186",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.283 18.7129H417.066",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.283 26.6455H417.066",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.402 26.6455H431.186",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.066 16.6553H417.283",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.066 16.655V16.3301",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.066 13.5954V13.2705",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.066 16.3301V13.5957",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.066 13.2705H417.283",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.252 18.1982L411.739 18.2253",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.902 18.5234L417.066 18.713",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.252 18.713C411.252 18.713 411.252 18.6317 411.252 18.6047C411.252 18.5776 411.252 18.5505 411.252 18.4964C411.252 18.4422 411.252 18.3881 411.252 18.3339C411.252 18.2798 411.252 18.2527 411.252 18.2256C411.252 18.2256 411.252 18.2256 411.252 18.1986",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.252 27.1596L411.739 27.1055",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.902 26.835L417.066 26.6455",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.252 27.1599C411.252 27.1599 411.252 27.1599 411.252 27.1328C411.252 27.1328 411.252 27.0787 411.252 27.0245C411.252 26.9704 411.252 26.9162 411.252 26.8621C411.252 26.835 411.252 26.8079 411.252 26.7538C411.252 26.6997 411.252 26.6726 411.252 26.6455",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.252 26.6454V18.7129",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.008 27.1599V26.6455",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.008 18.7126V18.1982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.008 18.7129V26.6454",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.252 27.1592H410.008",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.252 26.6455V27.1599",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.252 18.1982H410.008",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.252 18.1982V18.7126",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.252 18.7129V26.6454",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.076 27.5391H417.391",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.391 27.539V10.0225",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.076 27.539V10.0225",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.238 28.0535V27.5391",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.902 27.539V10.0225",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.238 27.5391H431.076",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.391 27.5391H414.902",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.363 13.1895V28.0528",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.363 28.0527H431.24",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.738 29.6504C411.738 30.246 412.198 30.7063 412.793 30.7063",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.738 14.3271V29.6507",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.793 13.2705C412.198 13.2705 411.738 13.7308 411.738 14.3264",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.362 13.2705H412.793",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.363 28.0534V10.0225",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.238 29.6501V28.0527",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.184 30.7063C430.779 30.7063 431.238 30.246 431.238 29.6504",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.793 30.7061H430.184",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.132 20.5537H386.91",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.91 20.5537V20.7703",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.133 20.5537V20.7703",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.91 20.7705V24.5879",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.133 20.7705V24.5879",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.132 24.7773H386.91",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.91 24.5879V24.7774",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.133 24.5879V24.7774",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.91 20.0664V20.5537",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.133 20.0664V20.5537",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.91 24.7773V25.2917",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.133 24.7773V25.2917",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.132 19.417H386.91",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.91 19.417V19.6065",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.133 19.417V19.6065",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.91 19.6064V20.0667",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.133 19.6064V20.0667",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.91 25.291V25.7242",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.133 25.291V25.7242",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.132 25.9414H386.91",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.91 25.7246V25.9412",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.133 25.7246V25.9412",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.911 20.5537H386.479",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.911 24.7773H386.479",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.911 19.417H386.613",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.911 25.9414H386.613",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.479 19.417H386.614",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.614 25.9414H386.479",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.403 19.417H395.754",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.403 20.0117H395.754",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.404 19.417V20.0126",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.403 25.3457H395.754",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.754 25.3459V24.7773",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.754 20.5532V20.0117",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.404 20.0117V25.3452",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.755 20.5537H395.133",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.755 24.7773H395.133",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.403 25.9414H395.754",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.404 25.9413V25.3457",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.755 19.417H395.133",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.755 25.9414H395.133",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.423 19.417H386.342",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.232 21.312V20.7705",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.232 24.0459V24.5874",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.232 24.0459H382.854",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.854 21.3115H383.232",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.637 21.3115C382.556 22.232 382.556 23.1525 382.637 24.0459",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.637 21.3115H382.853",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.853 24.0459H382.637",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.232 20.5537H386.343",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.232 20.7703V20.5537",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.232 24.7773H386.343",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.232 24.5879V24.7774",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.231 20.5537H382.609",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.232,
    cy: 20.5538,
    rx: 0.378648,
    ry: 0.379029,
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.609 24.8037H383.231",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.232 24.7773V24.8056",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.582 25.3185C382.582 25.3185 382.582 25.1832 382.555 25.129C382.528 25.0749 382.555 24.9937 382.555 24.9395C382.555 24.8854 382.555 24.8583 382.555 24.8312C382.555 24.8041 382.555 24.7771 382.555 24.75",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.611 24.8037C382.611 24.8037 382.611 24.8037 382.583 24.8037",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.611 20.5537C382.611 20.5537 382.611 20.5537 382.583 20.5537",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.502 20.6076C382.502 20.6076 382.502 20.5535 382.502 20.4993C382.502 20.4452 382.502 20.391 382.502 20.3369C382.502 20.2827 382.502 20.2286 382.502 20.2015C382.502 20.1744 382.502 20.0932 382.502 20.0391",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.503 20.6074C382.34 21.9882 382.34 23.3689 382.503 24.7497",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.582 25.3184C382.582 25.4808 382.636 25.6162 382.663 25.7515",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.663 19.6064C382.636 19.7418 382.609 19.9043 382.582 20.0396",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.854 19.417H386.126",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.854 25.9414H386.126",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.664 19.6073V19.5791",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.664 25.7802V25.752",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.664 19.5787V19.5246C382.664 19.5246 382.691 19.4704 382.718 19.4704C382.745 19.4704 382.772 19.4434 382.772 19.4434C382.772 19.4434 382.826 19.4434 382.853 19.4434",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.853 25.941C382.853 25.941 382.799 25.941 382.772 25.941C382.745 25.941 382.718 25.941 382.718 25.914C382.718 25.8869 382.691 25.8869 382.664 25.8598V25.8057",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.127 19.417H386.343",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.73 19.498H402.084",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.084 20.7705H398.73",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.73 24.5879H402.084",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.457 19.498H397.972",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.457 19.877H397.972",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.459 19.877H396.432L396.404 19.9045",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.459 25.4817L396.432 25.4541H396.404",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.73 20.7704C398.541 20.4455 398.27 20.1477 398 19.877",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.973 25.4813C398.27 25.2377 398.514 24.9128 398.703 24.5879",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.457 25.4814H397.972",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.084 19.5263V19.498",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.414 20.7705H402.084",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.084 19.498H409.414",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.084 25.833H398.73",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.084 24.5879H409.414",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.973 19.498H398.73",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.084 24.5605V24.5888",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.73 19.5263V19.498",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.73 24.5605V24.5888",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.459 25.8344H396.432H396.404V25.8068V25.7793",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.457 25.833H397.972",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.414 25.833H402.084",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.73 25.833H397.973",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.404 19.5531L396.432 19.5256L396.459 19.498",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.412 19.498H409.953",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.008 19.5531L409.981 19.5256L409.953 19.498",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.953 25.833H409.412",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.008 25.7793L409.981 25.8068L409.953 25.8344",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.363 10.0225H414.904",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.391 10.0225H431.076",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.943 18.6855V18.7138",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.943 26.6719V26.7001",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.402 26.7006V26.6455",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.479 19.417H386.424",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.477 20.5537H386.342",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.477 24.7773H386.342",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.479 25.9414H386.127",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.412 24.5879H410.007",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.412 20.7705H410.007",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.331 19.2538C446.063 19.2538 446.656 18.6598 446.656 17.9272C446.656 17.1945 446.063 16.6006 445.331 16.6006C444.599 16.6006 444.006 17.1945 444.006 17.9272C444.006 18.6598 444.599 19.2538 445.331 19.2538Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.063 8.58729C526.279 7.88338 525.9 7.15239 525.197 6.93581C524.494 6.71922 523.764 7.09825 523.547 7.80216C523.331 8.45192 523.655 9.15583 524.305 9.42657",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.504 32.7906C463.46 32.7906 464.235 32.0148 464.235 31.0579C464.235 30.101 463.46 29.3252 462.504 29.3252C461.548 29.3252 460.773 30.101 460.773 31.0579C460.773 32.0148 461.548 32.7906 462.504 32.7906Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.846 19.8497L446.412 18.6855",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.358 17.0069L442.951 15.8428",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.871 14.7061L442.951 15.8431",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.357 14.543L443.869 14.7054",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.441 17.873L445.357 14.543",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.441 17.873L447.846 19.8494",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.01 7.61251C525.686 6.96274 524.901 6.66494 524.252 6.98982C523.657 7.26055 523.36 7.93739 523.549 8.56008",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.924 6.82705L525.846 4.95898",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.2 5.58167L525.848 4.95898",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.199 5.58203L527.713 6.96278",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.529 32.9531C460.99 34.1444 462.964 34.4692 464.722 33.7924",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.53 32.953L449.469 24.7227",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.385 21.3933L442.031 18.6318",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.869 17.1426L442.031 18.6316",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.869 17.1421L442.87 15.9238",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.869 15.9238L444.303 17.088",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.332 18.7666L447.847 19.9849",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.846 19.9856L449.523 17.9551",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.503 26.9432L454.77 22.2324",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.686 18.9026L449.523 17.9551",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.504 26.9434C461.964 28.1346 463.939 28.4595 465.697 27.7826",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.723 27.7826L520.816 6.88184",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.576 8.6416C523.711 8.99356 523.982 9.26429 524.306 9.39966",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.064 8.58705C526.146 8.28925 526.146 7.99144 526.064 7.7207",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.01 7.61265L527.714 6.96289",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.816 9.20933L523.547 8.55957",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.924 6.82715L521.816 9.20961",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.736 9.34455L520.816 6.88086",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.575 8.64062L521.736 9.34454",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.768 7.07129L526.037 7.72105",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.768 7.07129L527.984 7.66691",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.723 33.7922L504.129 18.8477",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.305 9.3997C524.873 9.64336 525.522 9.42678 525.873 8.93945",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.064 8.58691L525.983 8.74935L525.875 8.93887",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.469 24.7226L445.385 21.3926",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.77 22.2324L450.686 18.9023",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.305 9.39912C524.981 9.66985 525.738 9.34497 526.009 8.66813C526.009 8.64106 526.009 8.61399 526.036 8.58691",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.984 7.66699L528.309 8.53334",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.713 9.91395L528.308 8.5332",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.129 18.8483L527.713 9.91406",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.233 19.2538C424.965 19.2538 425.559 18.6598 425.559 17.9272C425.559 17.1945 424.965 16.6006 424.233 16.6006C423.502 16.6006 422.908 17.1945 422.908 17.9272C422.908 18.6598 423.502 19.2538 424.233 19.2538Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.967 8.58729C505.183 7.88338 504.805 7.15239 504.101 6.93581C503.398 6.71922 502.668 7.09825 502.452 7.80216C502.235 8.45192 502.56 9.15583 503.209 9.42657",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.409 32.7906C442.365 32.7906 443.14 32.0148 443.14 31.0579C443.14 30.101 442.365 29.3252 441.409 29.3252C440.453 29.3252 439.678 30.101 439.678 31.0579C439.678 32.0148 440.453 32.7906 441.409 32.7906Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.75 19.8497L425.316 18.6855",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.287 17.0069L421.854 15.8428",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.773 14.7061L421.854 15.8431",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.261 14.543L422.773 14.7054",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.346 17.873L424.262 14.543",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.346 17.873L426.75 19.8494",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.914 7.61265L506.645 6.96289",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.912 7.61251C504.588 6.96274 503.804 6.66494 503.154 6.98982C502.559 7.26055 502.262 7.93739 502.451 8.56008",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.721 9.21031L502.452 8.56055",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.828 6.82715L500.721 9.20961",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.828 6.82705L504.751 4.95898",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.104 5.58167L504.752 4.95898",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.104 5.58203L506.644 6.96278",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.434 32.9531C439.894 34.1444 441.868 34.4692 443.626 33.7924",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.434 32.953L428.373 24.7227",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.316 21.3933L420.936 18.6318",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.771 17.1426L420.934 18.6316",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.771 17.1421L421.772 15.9238",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.773 15.9238L423.207 17.088",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.262 18.7666L426.776 19.9849",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.777 19.9856L428.427 17.9551",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.435 26.9432L433.674 22.2324",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.616 18.9026L428.426 17.9551",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.434 26.9434C440.894 28.1346 442.869 28.4595 444.627 27.7826",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.627 27.7826L499.72 6.88184",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.667 9.34552L499.721 6.88184",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.48 8.6416L500.668 9.34551",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.479 8.6416C502.614 8.99356 502.884 9.26429 503.209 9.39966",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.967 8.58705C505.048 8.28925 505.048 7.99144 504.967 7.7207",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.67 7.07129L504.939 7.72105",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.672 7.07129L506.915 7.66691",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.654 33.7922L483.034 18.8477",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.209 9.3997C503.777 9.64336 504.426 9.42678 504.778 8.93945",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.967 8.58691L504.913 8.74935L504.805 8.93887",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.371 24.7226L424.314 21.3926",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.674 22.2324L429.617 18.9023",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.209 9.39912C503.885 9.66985 504.642 9.34497 504.913 8.66813C504.913 8.64106 504.913 8.61399 504.94 8.58691",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.914 7.66699L507.239 8.53334",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.617 9.91395L507.239 8.5332",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.033 18.8483L506.618 9.91406",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.252 0.952148H579.859",
    stroke: "#808284",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.859 0.952148L585.187 7.28734",
    stroke: "#808284",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.252 0.952148L405.951 7.28734",
    stroke: "#808284",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.33 212.667H246.46C245.309 212.667 244.377 213.6 244.377 214.752V215.591C244.377 216.742 245.309 217.676 246.46 217.676H254.33C255.48 217.676 256.413 216.742 256.413 215.591V214.752C256.413 213.6 255.48 212.667 254.33 212.667Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.633 69.3395L180.737 130.715C180.737 130.715 180.601 132.231 181.873 131.96L221.82 125.409C221.82 125.409 233.504 124.407 236.263 112.088L240.157 94.1117L243.43 67.5797C243.43 67.5797 244.187 59.9179 237.534 61.0279L220.197 62.4086C220.197 62.4086 199.48 64.4392 191.041 67.2006C191.041 67.2006 187.769 67.9587 187.66 69.3395H187.633Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.657 75.2688C182.602 72.8051 180.412 74.0775 180.412 74.0775L157.125 98.2L154.745 100.772L151.012 129.389C151.012 129.389 150.255 135.209 157.233 135.913L158.017 135.751L174.84 132.908C176.652 132.313 176.544 130.932 176.544 130.932L182.629 75.2958L182.657 75.2688Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.225 10.7256V219.976L257.982 222.765V250.163",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42483 194.013L7.69458 196.396L5.04404 197.1L4.71949 197.316L3.74582 198.291L3.52945 198.832L3.12375 201.431C3.1508 201.702 3.39422 201.892 3.66468 201.892H5.01699L5.09813 203.57L2.36646 204.788C1.47393 205.249 1.55507 206.007 1.55507 206.007L1.50098 208.985L2.01486 209.445V211.99C2.01486 212.504 2.42055 212.938 2.96148 212.938H4.34084V218.109L1.90667 218.542L2.33941 227.205L3.06966 234.19L4.85472 235.029L2.74511 236.085V237.872L36.1202 248.458L37.4996 249.405H62.9501C60.6783 240.065 64.3836 228.207 65.222 225.743C70.3338 206.223 88.0762 191.82 109.172 191.82C130.268 191.82 149.579 207.523 153.745 228.342C156.287 238.766 157.504 249.703 157.504 249.703V263.727C157.504 264.621 158.126 265.379 158.992 265.541L160.236 265.785L160.29 267.139C160.29 267.626 160.777 267.978 161.263 267.87L164.455 267.03C164.644 266.976 164.779 266.814 164.779 266.624V265.054L164.915 250.976H169.107L252.68 250.136H449.252C449.55 250.136 449.82 249.893 449.82 249.568C449.82 228.64 455.284 220.626 455.527 220.085C463.019 205.086 478.516 195.15 496.421 195.15C514.326 195.15 528.579 204.355 536.396 218.352C536.396 218.352 542.4 226.853 542.4 246.427L543.238 259.125C543.238 263.781 545.023 264.404 545.023 264.404L550.297 266.732H551.677V249.595L607.365 241.554L611.557 241.798C612.504 241.852 613.423 241.744 614.316 241.446L622.781 238.711C624.458 237.872 624.458 236.6 624.458 236.6L625.729 229.29C625.729 226.745 624.242 226.853 624.242 226.853L620.861 226.42V224.687L629.056 219.029C629.597 218.623 629.895 218 629.895 217.35V207.415C629.895 205.953 629.218 204.572 628.055 203.678L623.106 199.834L624.35 195.8L623.755 140.57L622.105 116.827C622.349 103.236 616.831 56.9673 616.831 56.9673L617.264 56.6153C617.94 56.0468 618.238 55.1804 618.075 54.3412L614.803 36.8517L614.749 36.6893C614.451 35.8229 614.478 34.8753 614.776 34.0361L615.29 32.6012C615.29 25.8057 607.717 12.8375 607.717 12.8375C604.66 10.7529 595.302 9.34505 595.302 9.34505L593.166 9.48042C583.862 7.47698 568.283 7.96431 568.283 7.96431H266.501C226.553 7.96431 196.721 31.6807 196.721 31.6807L165.915 57.1026L165.78 59.0249L164.022 60.4327L97.0826 129.66L86.1829 129.281C85.1552 129.605 84.8576 128.956 84.8576 128.956C81.9637 131.067 80.1516 131.473 80.1516 131.473C66.8178 135.318 43.8555 146.851 43.8555 146.851L29.3587 154.161C16.5117 160.767 14.2939 168.835 14.2939 168.835L13.8611 170.351L20.7579 169.539L23.5437 169.458C24.6797 169.485 25.4099 168.754 25.4099 168.754C25.9508 168.077 28.7095 166.479 28.7095 166.479C37.3644 160.875 42.8007 160.09 42.8007 160.09C53.8626 151.156 110.389 129.66 110.389 129.66C110.389 129.66 123.967 129.849 124.805 131.04",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4356 170.974H19.4327L13.1309 171.678C12.9957 171.678 12.8605 171.759 12.7793 171.867L11.995 172.896L11.8057 173.898L18.2156 173.302H21.5694",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.297 176.984L11.6429 177.336H10.8585L9.99303 178.284L9.80371 179.286L18.1069 179.231",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83028 183.915L8.07298 184.484L7.69434 185.594L7.74843 186.162L15.078 186.108L16.0516 183.645L8.83028 183.915Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.969 57.1022L178.356 58.51C178.356 58.51 198.965 36.8783 220.575 23.8018C220.575 23.8018 235.91 12.4851 259.522 10.4817C259.522 10.4817 276.777 7.96387 318.834 7.96387",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.314 7.96387C422.314 7.96387 551.893 9.45291 589.325 11.2127L595.303 9.34461",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.708 200.132C600.981 112.603 589.352 11.2129 589.352 11.2129",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.68 249.92V246.915L444.194 245.67C444.194 245.67 444.952 217.243 456.5 206.169L458.502 200.646C458.502 200.646 483.114 173.979 520.303 191.09C520.303 191.09 529.093 195.882 533.88 201.648L536.395 206.684C536.395 206.684 547.944 211.882 549.215 266.218",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.325 11.2129C589.325 11.2129 594.058 12.0522 600.089 13.6766C600.089 13.6766 602.037 14.6512 603.091 17.3586C603.091 17.3586 609.61 36.2558 614.072 91.8377L618.021 156.354L616.939 157.626C616.642 157.978 616.533 158.465 616.615 158.926L617.967 164.909V196.26L616.047 200.104H596.438L594.923 201.106L594.409 212.179C594.409 212.179 594.166 219.462 586.377 219.462L543.914 221.222",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.6 208.416H616.047V200.132L620.753 200.7L620.835 224.769",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.047 208.416L618.941 208.768L618.508 222.494L618.86 225.716C618.86 225.716 619.022 226.582 620.158 226.582L620.807 226.528",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.834 59.0251L178.221 60.1351V58.5107",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1367 129.659H110.389L150.391 88.589L178.222 60.1348",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 118.234L116.638 140.895L114.122 144.414C114.122 144.414 112.987 146.309 115.367 146.309L220.901 128.062C220.901 128.062 232.964 128.82 238.617 111.953L242.511 94.3553L245.865 66.957C245.919 66.5779 245.919 66.1989 245.892 65.8199C245.757 63.7082 244.648 57.8874 236.399 58.862C236.399 58.862 207.973 61.0279 196.776 63.4374C196.776 63.4374 184.47 65.4409 178.195 72.859L149.039 103.533",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.708 61.6508L163.969 60.5137",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7578 161.606C58.7578 161.606 96.0817 150.316 115.393 146.31",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8633 211.313L93.7017 213.019",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.4 280.107L127.212 281.813",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.362 250.136C108.333 250.136 106.684 248.485 106.684 246.454C106.684 244.424 108.333 242.772 110.362 242.772C112.39 242.772 114.04 244.424 114.04 246.454C114.04 248.485 112.39 250.136 110.362 250.136Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.362 223.659C97.8127 223.659 87.6162 233.866 87.6162 246.428C87.6162 258.99 97.8127 269.197 110.362 269.197C122.912 269.197 133.108 258.99 133.108 246.428C133.108 233.866 122.912 223.659 110.362 223.659ZM123.993 232.404C124.102 232.269 124.318 232.241 124.426 232.377C125.616 233.568 126.698 234.949 127.564 236.492C128.456 238.035 129.105 239.633 129.538 241.284C129.592 241.446 129.457 241.636 129.295 241.636L127.753 241.825L119.72 242.827C119.071 242.881 118.422 242.556 118.07 241.961C117.719 241.365 117.773 240.634 118.151 240.093L123.047 233.622L123.993 232.377V232.404ZM105.223 227.206C106.873 226.773 108.577 226.529 110.362 226.529C112.147 226.529 113.851 226.773 115.501 227.206C115.663 227.26 115.771 227.449 115.69 227.612L115.095 229.047L111.958 236.519C111.687 237.115 111.092 237.521 110.389 237.521C109.686 237.521 109.091 237.115 108.821 236.519L105.683 229.047L105.088 227.612C105.007 227.449 105.088 227.26 105.277 227.206H105.223ZM91.1322 241.284C91.565 239.633 92.2411 238.035 93.1066 236.492C93.9991 234.949 95.0539 233.568 96.244 232.377C96.3792 232.241 96.5685 232.269 96.6767 232.404L97.6233 233.649L102.519 240.093C102.897 240.634 102.951 241.365 102.6 241.961C102.248 242.556 101.599 242.881 100.95 242.827L92.9173 241.825L91.3756 241.636C91.2134 241.636 91.0781 241.446 91.1322 241.284ZM96.7038 260.479C96.5956 260.614 96.3792 260.642 96.271 260.506C95.081 259.315 93.9991 257.934 93.1337 256.391C92.2411 254.848 91.592 253.25 91.1593 251.599C91.1052 251.437 91.2404 251.247 91.4027 251.247L92.9443 251.058L100.977 250.056C101.626 250.002 102.275 250.327 102.627 250.922C102.979 251.518 102.924 252.249 102.546 252.79L97.6504 259.261L96.7038 260.506V260.479ZM115.474 265.677C113.824 266.11 112.12 266.354 110.335 266.354C108.55 266.354 106.846 266.11 105.196 265.677C105.034 265.623 104.926 265.434 105.007 265.271L105.602 263.836L108.739 256.364C109.01 255.768 109.605 255.362 110.308 255.362C111.011 255.362 111.606 255.768 111.877 256.364L115.014 263.836L115.609 265.271C115.69 265.434 115.609 265.623 115.42 265.677H115.474ZM129.565 251.599C129.132 253.25 128.456 254.848 127.591 256.391C126.698 257.934 125.643 259.315 124.453 260.506C124.318 260.642 124.129 260.614 124.021 260.479L123.074 259.234L118.179 252.79C117.8 252.249 117.746 251.518 118.097 250.922C118.449 250.327 119.098 250.002 119.747 250.056L127.78 251.058L129.322 251.247C129.484 251.247 129.619 251.437 129.565 251.599Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6771 233.649L96.7304 232.403C96.6223 232.268 96.4059 232.241 96.2977 232.376C95.1077 233.567 94.0258 234.948 93.1603 236.491C92.2678 238.034 91.6187 239.632 91.1859 241.283C91.1318 241.446 91.2671 241.635 91.4294 241.635L92.971 241.825C93.8094 238.684 95.4593 235.869 97.7041 233.649H97.6771Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.977 242.827C101.626 242.881 102.275 242.556 102.627 241.961C102.978 241.365 102.924 240.634 102.545 240.093L97.6501 233.622C95.4053 235.842 93.7554 238.658 92.917 241.798L100.95 242.8L100.977 242.827Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9446 251.058L91.403 251.247C91.2407 251.247 91.1055 251.437 91.1596 251.599C91.5923 253.251 92.2685 254.848 93.134 256.391C94.0265 257.934 95.0813 259.315 96.2713 260.506C96.4066 260.642 96.5959 260.615 96.7041 260.479L97.6507 259.234C95.4058 257.014 93.756 254.198 92.9176 251.058H92.9446Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.546 252.763C102.924 252.221 102.979 251.517 102.627 250.895C102.275 250.299 101.626 249.974 100.977 250.028L92.9443 251.03C93.7828 254.171 95.4326 256.986 97.6774 259.206L102.573 252.763H102.546Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.095 229.02L115.69 227.585C115.771 227.422 115.69 227.233 115.5 227.179C113.851 226.746 112.147 226.502 110.362 226.502C108.577 226.502 106.873 226.746 105.223 227.179C105.06 227.233 104.952 227.422 105.033 227.585L105.628 229.02C107.143 228.614 108.712 228.397 110.335 228.397C111.957 228.397 113.553 228.614 115.041 229.02H115.095Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.794 236.491C109.064 237.087 109.659 237.493 110.362 237.493C111.066 237.493 111.661 237.087 111.931 236.491L115.068 229.019C113.554 228.613 111.985 228.396 110.362 228.396C108.74 228.396 107.144 228.613 105.656 229.019L108.794 236.491Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.656 263.863L105.061 265.298C104.979 265.461 105.061 265.65 105.25 265.704C106.9 266.137 108.604 266.381 110.389 266.381C112.174 266.381 113.878 266.137 115.528 265.704C115.69 265.65 115.798 265.461 115.717 265.298L115.122 263.863C113.607 264.269 112.039 264.486 110.416 264.486C108.793 264.486 107.197 264.269 105.71 263.863H105.656Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.931 256.39C111.661 255.795 111.066 255.389 110.362 255.389C109.659 255.389 109.064 255.795 108.794 256.39L105.656 263.863C107.171 264.269 108.74 264.485 110.362 264.485C111.985 264.485 113.581 264.269 115.068 263.863L111.931 256.39Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.808 241.825L129.349 241.635C129.512 241.635 129.647 241.446 129.593 241.283C129.16 239.632 128.484 238.034 127.618 236.491C126.726 234.948 125.671 233.567 124.481 232.376C124.346 232.241 124.156 232.268 124.048 232.403L123.102 233.649C125.346 235.869 126.996 238.684 127.835 241.825H127.808Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.178 240.119C117.799 240.661 117.745 241.365 118.097 241.987C118.449 242.583 119.098 242.908 119.747 242.854L127.78 241.852C126.941 238.711 125.291 235.896 123.046 233.676L118.151 240.119H118.178Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.349 251.247L127.807 251.058C126.969 254.198 125.319 257.014 123.074 259.234L124.021 260.479C124.129 260.615 124.345 260.642 124.454 260.506C125.644 259.315 126.725 257.934 127.591 256.391C128.483 254.848 129.133 253.251 129.565 251.599C129.619 251.437 129.484 251.247 129.322 251.247H129.349Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.807 251.057L119.774 250.056C119.125 250.001 118.476 250.326 118.124 250.922C117.773 251.518 117.827 252.249 118.205 252.79L123.101 259.261C125.346 257.041 126.995 254.225 127.834 251.084L127.807 251.057Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.362 285.657C132.006 285.657 149.552 268.094 149.552 246.428C149.552 224.762 132.006 207.198 110.362 207.198C88.7179 207.198 71.1719 224.762 71.1719 246.428C71.1719 268.094 88.7179 285.657 110.362 285.657Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.362 285.657C132.006 285.657 149.552 268.094 149.552 246.428C149.552 224.762 132.006 207.198 110.362 207.198C88.7179 207.198 71.1719 224.762 71.1719 246.428C71.1719 268.094 88.7179 285.657 110.362 285.657Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.362 283.6C130.871 283.6 147.497 266.957 147.497 246.428C147.497 225.898 130.871 209.256 110.362 209.256C89.8532 209.256 73.2275 225.898 73.2275 246.428C73.2275 266.957 89.8532 283.6 110.362 283.6Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.221 211.313L481.059 213.019",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.73 280.107L514.569 281.813",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.719 250.136C495.691 250.136 494.041 248.485 494.041 246.454C494.041 244.424 495.691 242.772 497.719 242.772C499.748 242.772 501.398 244.424 501.398 246.454C501.398 248.485 499.748 250.136 497.719 250.136Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.719 223.659C485.169 223.659 474.973 233.866 474.973 246.428C474.973 258.99 485.169 269.197 497.719 269.197C510.268 269.197 520.465 258.99 520.465 246.428C520.465 233.866 510.268 223.659 497.719 223.659ZM511.35 232.404C511.458 232.269 511.674 232.241 511.783 232.377C512.973 233.568 514.055 234.949 514.92 236.492C515.813 238.035 516.462 239.633 516.894 241.284C516.949 241.446 516.813 241.636 516.651 241.636L515.109 241.825L507.077 242.827C506.428 242.881 505.778 242.556 505.427 241.961C505.075 241.365 505.129 240.634 505.508 240.093L510.403 233.622L511.35 232.377V232.404ZM492.58 227.206C494.23 226.773 495.934 226.529 497.719 226.529C499.504 226.529 501.208 226.773 502.857 227.206C503.02 227.26 503.128 227.449 503.047 227.612L502.452 229.047L499.314 236.519C499.044 237.115 498.449 237.521 497.746 237.521C497.042 237.521 496.447 237.115 496.177 236.519L493.04 229.047L492.445 227.612C492.363 227.449 492.445 227.26 492.634 227.206H492.58ZM478.489 241.284C478.921 239.633 479.598 238.035 480.463 236.492C481.356 234.949 482.41 233.568 483.6 232.377C483.736 232.241 483.925 232.269 484.033 232.404L484.98 233.649L489.875 240.093C490.254 240.634 490.308 241.365 489.956 241.961C489.605 242.556 488.956 242.881 488.306 242.827L480.274 241.825L478.732 241.636C478.57 241.636 478.435 241.446 478.489 241.284ZM484.06 260.479C483.952 260.614 483.736 260.642 483.628 260.506C482.437 259.315 481.356 257.934 480.49 256.391C479.598 254.848 478.948 253.25 478.516 251.599C478.462 251.437 478.597 251.247 478.759 251.247L480.301 251.058L488.334 250.056C488.983 250.002 489.632 250.327 489.983 250.922C490.335 251.518 490.281 252.249 489.902 252.79L485.007 259.261L484.06 260.506V260.479ZM502.83 265.677C501.181 266.11 499.477 266.354 497.692 266.354C495.907 266.354 494.203 266.11 492.553 265.677C492.39 265.623 492.282 265.434 492.363 265.271L492.958 263.836L496.096 256.364C496.366 255.768 496.961 255.362 497.665 255.362C498.368 255.362 498.963 255.768 499.233 256.364L502.371 263.836L502.966 265.271C503.047 265.434 502.966 265.623 502.776 265.677H502.83ZM516.921 251.599C516.489 253.25 515.813 254.848 514.947 256.391C514.055 257.934 513 259.315 511.81 260.506C511.675 260.642 511.485 260.614 511.377 260.479L510.43 259.234L505.535 252.79C505.156 252.249 505.102 251.518 505.454 250.922C505.805 250.327 506.455 250.002 507.104 250.056L515.136 251.058L516.678 251.247C516.84 251.247 516.976 251.437 516.921 251.599Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.007 233.649L484.06 232.403C483.952 232.268 483.736 232.241 483.628 232.376C482.438 233.567 481.356 234.948 480.49 236.491C479.598 238.034 478.949 239.632 478.516 241.283C478.462 241.446 478.597 241.635 478.759 241.635L480.301 241.825C481.139 238.684 482.789 235.869 485.034 233.649H485.007Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.335 242.827C488.984 242.881 489.633 242.556 489.985 241.961C490.337 241.365 490.283 240.634 489.904 240.093L485.008 233.622C482.764 235.842 481.114 238.658 480.275 241.798L488.308 242.8L488.335 242.827Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.301 251.058L478.759 251.247C478.597 251.247 478.462 251.437 478.516 251.599C478.949 253.251 479.625 254.848 480.49 256.391C481.383 257.934 482.438 259.315 483.628 260.506C483.763 260.642 483.952 260.615 484.06 260.479L485.007 259.234C482.762 257.014 481.112 254.198 480.274 251.058H480.301Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.902 252.763C490.281 252.221 490.335 251.517 489.983 250.895C489.632 250.299 488.983 249.974 488.334 250.028L480.301 251.03C481.139 254.171 482.789 256.986 485.034 259.206L489.929 252.763H489.902Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.425 229.02L503.02 227.585C503.101 227.422 503.02 227.233 502.83 227.179C501.181 226.746 499.477 226.502 497.692 226.502C495.907 226.502 494.203 226.746 492.553 227.179C492.391 227.233 492.282 227.422 492.364 227.585L492.959 229.02C494.473 228.614 496.042 228.397 497.665 228.397C499.287 228.397 500.883 228.614 502.371 229.02H502.425Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.151 236.491C496.421 237.087 497.016 237.493 497.72 237.493C498.423 237.493 499.018 237.087 499.288 236.491L502.426 229.019C500.911 228.613 499.342 228.396 497.72 228.396C496.097 228.396 494.501 228.613 493.014 229.019L496.151 236.491Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.986 263.863L492.391 265.298C492.31 265.461 492.391 265.65 492.58 265.704C494.23 266.137 495.934 266.381 497.719 266.381C499.504 266.381 501.208 266.137 502.858 265.704C503.02 265.65 503.128 265.461 503.047 265.298L502.452 263.863C500.937 264.269 499.369 264.486 497.746 264.486C496.123 264.486 494.527 264.269 493.04 263.863H492.986Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.288 256.39C499.018 255.795 498.423 255.389 497.72 255.389C497.016 255.389 496.421 255.795 496.151 256.39L493.014 263.863C494.528 264.269 496.097 264.485 497.72 264.485C499.342 264.485 500.938 264.269 502.426 263.863L499.288 256.39Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.138 241.825L516.679 241.635C516.842 241.635 516.977 241.446 516.923 241.283C516.49 239.632 515.814 238.034 514.948 236.491C514.056 234.948 513.001 233.567 511.811 232.376C511.676 232.241 511.486 232.268 511.378 232.403L510.432 233.649C512.676 235.869 514.326 238.684 515.165 241.825H515.138Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.536 240.119C505.157 240.661 505.103 241.365 505.454 241.987C505.806 242.583 506.455 242.908 507.104 242.854L515.137 241.852C514.299 238.711 512.649 235.896 510.404 233.676L505.508 240.119H505.536Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.679 251.247L515.137 251.058C514.299 254.198 512.649 257.014 510.404 259.234L511.351 260.479C511.459 260.615 511.675 260.642 511.784 260.506C512.974 259.315 514.056 257.934 514.921 256.391C515.814 254.848 516.463 253.251 516.895 251.599C516.949 251.437 516.814 251.247 516.652 251.247H516.679Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.137 251.057L507.104 250.056C506.455 250.001 505.806 250.326 505.454 250.922C505.103 251.518 505.157 252.249 505.536 252.79L510.431 259.261C512.676 257.041 514.326 254.225 515.164 251.084L515.137 251.057Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.719 285.657C519.363 285.657 536.909 268.094 536.909 246.428C536.909 224.762 519.363 207.198 497.719 207.198C476.075 207.198 458.529 224.762 458.529 246.428C458.529 268.094 476.075 285.657 497.719 285.657Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.719 285.657C519.363 285.657 536.909 268.094 536.909 246.428C536.909 224.762 519.363 207.198 497.719 207.198C476.075 207.198 458.529 224.762 458.529 246.428C458.529 268.094 476.075 285.657 497.719 285.657Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.719 283.6C518.227 283.6 534.853 266.957 534.853 246.428C534.853 225.898 518.227 209.256 497.719 209.256C477.21 209.256 460.584 225.898 460.584 246.428C460.584 266.957 477.21 283.6 497.719 283.6Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.079 228.748L621.592 235.354C621.483 235.896 621.024 235.625 621.024 235.625L618.13 234.894C617.21 234.65 617.48 232.809 617.48 232.809L618.048 229.534C618.13 229.073 618.238 228.776 618.319 228.613C618.373 228.478 618.508 228.396 618.67 228.396H619.293C619.725 228.396 620.131 228.396 620.564 228.478L623.052 228.776L623.079 228.748Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.432 219.354L587.377 244.613",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.467 138.377C597.467 138.377 606.392 138.566 613.073 139.433C614.29 139.595 615.426 140.191 616.21 141.138C616.778 141.842 617.238 142.817 617.265 144.117",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.393 53.8264C606.311 46.0022 603.39 28.4044 603.39 28.4044L601.172 19.01L600.469 16.5733C599.604 13.6765 600.063 13.6765 600.063 13.6765L606.771 12.377",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.416 28.4043C603.416 28.4043 606.121 43.2406 607.419 53.8263C607.419 53.8263 610.719 83.4717 611.151 91.9999L613.829 139.541L613.883 142.925L614.721 143.764V154.919L613.964 157.112L614.126 160.55L615.289 162.31V171.704L614.289 173.139V176.902L615.641 178.5V188.219L614.397 189.464V197.18L613.991 200.023",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.021 156.354C618.021 156.354 622.971 159.007 623.999 164.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.615 158.357C616.615 158.357 620.753 159.982 622.836 163.745C623.215 164.449 623.485 165.207 623.62 165.992L624.08 168.483",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.182 208.416L613.424 227.286L615.047 226.528C615.047 226.528 616.047 226.014 617.183 226.014L619.888 226.528",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7041 236.329C59.7319 225.553 64.9788 215.753 64.9788 215.753C73.0657 199.346 89.9696 188.057 109.497 188.057C129.024 188.057 147.254 200.267 154.935 217.729C154.935 217.729 160.642 237.114 161.345 252.248L161.507 260.559C161.507 260.559 161.21 264.891 164.726 265.758L163.779 266.055C163.454 266.164 163.103 266.191 162.751 266.164L160.236 265.866",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6258 236.519H12.2656",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.095 153.755C226.851 153.755 225.769 153.051 225.255 151.995L221.252 151.914C221.874 155.136 224.687 157.572 228.095 157.572C231.502 157.572 234.153 155.298 234.883 152.212L230.88 152.131C230.34 153.105 229.312 153.755 228.122 153.755H228.095Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.094 147.42C229.284 147.42 230.339 148.07 230.853 149.044L234.856 148.963C234.126 145.904 231.367 143.603 228.067 143.603C224.768 143.603 221.847 146.039 221.225 149.261L225.227 149.18C225.741 148.151 226.823 147.42 228.067 147.42H228.094Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.094 153.755C229.284 153.755 230.339 153.105 230.852 152.131L225.254 152.022C225.768 153.051 226.85 153.782 228.094 153.782V153.755Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.094 147.42C226.85 147.42 225.768 148.124 225.254 149.18L230.852 149.071C230.312 148.097 229.284 147.447 228.094 147.447V147.42Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.883 148.963L230.853 149.045L225.254 149.18L221.252 149.261L217.844 149.315V149.884H218.547V151.292H217.844V151.833L221.252 151.914L225.254 151.996L230.853 152.104L234.883 152.212L240.914 152.321V148.828L234.883 148.963Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.843 149.884H216.734V151.292H217.843H218.546V149.884H217.843Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.656 101.909L179.222 65.2515C187.444 57.1024 211.299 54.7199 211.299 54.7199C230.096 52.2291 253.113 51.6064 253.113 51.6064H257.142",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.113 51.5801L248.759 166.399L245.243 173.275L243.052 200.944V205.98L241.537 222.332L240.266 230.509L238.021 241.473C238.021 241.473 237.507 244.37 232.882 244.072H168.729C168.729 244.072 166.754 244.289 166.754 242.638C166.754 242.638 164.834 228.559 162.508 221.412L162.292 220.275C162.292 220.275 159.939 211.638 153.096 200.268C153.096 200.268 146.118 191.333 137.274 185.648C136.841 185.377 136.598 184.89 136.598 184.375L136.652 142.574",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5737 199.59C65.5737 199.59 29.4669 201.377 7.09961 204.517L7.39712 197.668L8.80353 196.179L12.5359 193.986L24.1929 192.226L30.5217 191.955L45.0456 191.278",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.092 17.3588L609.339 16.0322",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.084 63.3027L178.357 66.2537L181.737 69.6379",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.572 65.4955L195.531 49.0889C195.531 49.0889 206.728 37.3661 228.96 25.6433C228.96 25.6433 250.408 13.7851 279.807 13.7851L322.459 13.5144C322.459 13.5144 352.886 13 395.674 13C395.674 13 489.146 13.1354 538.478 14.1642L589.595 15.3283",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.602 205.654H155.8L145.928 211.069",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.679 246.915H257.223L168.619 247.944",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.756 244.072V251.057",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.792 220.085H162.317L152.283 223.821",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.475 220.004V250.137",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.156 226.095C617.156 226.095 615.722 226.041 615.722 228.667L615.614 233.73C615.587 235.029 616.452 236.166 617.724 236.491L623.863 237.52",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.317 60.4053L613.801 61.407C613.801 61.407 612.178 61.1633 612.665 65.4409L615.803 97.523L616.939 118.64C616.939 118.64 616.939 129.822 621.591 136.373L623.727 141.03",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.078 199.861L620.752 200.701",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.52 143.683L612.26 143.439C613.666 143.439 615.073 143.683 616.371 144.198L617.209 144.522",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.764 155.515H612.26C613.667 155.515 615.073 155.758 616.372 156.273L617.21 156.598",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.736 161.2L612.206 160.605C613.612 160.496 615.019 160.659 616.371 161.092L617.237 161.363",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.52 171.082L613.558 171.813C614.613 171.867 615.668 171.813 616.695 171.678L617.967 171.515",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.412 177.309L613.072 176.849C614.695 176.795 616.29 177.093 617.805 177.688L617.967 177.742",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.25 187.38L613.532 188.165C614.506 188.219 615.479 188.219 616.453 188.165L617.886 188.111",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.898 196.017H617.778",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.52 145.038L612.26 144.794C613.666 144.794 615.073 145.038 616.371 145.552L617.209 145.877",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.764 156.868H612.26C613.667 156.868 615.073 157.112 616.372 157.626L616.885 157.87",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.736 162.554L612.206 161.958C613.612 161.85 615.019 162.012 616.371 162.446L617.48 162.879",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.52 172.436L613.558 173.167C614.613 173.221 615.668 173.167 616.695 173.031L617.967 172.869",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.412 178.663L613.072 178.203C614.695 178.148 616.29 178.446 617.805 179.042L617.967 179.096",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.25 188.733L613.532 189.519C614.506 189.573 615.479 189.573 616.453 189.519L617.886 189.464",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.898 197.37H616.967",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.785 166.426L257.224 165.722",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.27 173.302L257.224 172.814",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.551 67.2285L178.086 135.4",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7276 208.849C16.7276 208.849 11.9675 208.876 8.61374 209.634C8.61374 209.634 6.7205 209.824 6.82868 211.475L6.96392 212.748L8.34328 218.894L9.93901 224.227L11.102 227.422L13.2657 232.728L13.7255 233.676C13.7255 233.676 14.3205 235.219 16.1867 235.083H19.0536L23.0024 234.732L24.2735 234.542C24.2735 234.542 27.5732 234.109 26.5725 230.67L22.7049 220.68L18.702 210.095C18.702 210.095 18.3234 208.66 16.7547 208.795L16.7276 208.849Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2193 222.495L12.5631 222.765C11.0755 222.874 10.5346 221.601 10.5346 221.601C9.26345 218.785 7.91113 211.638 7.91113 211.638C7.91113 209.851 9.34459 209.96 9.34459 209.96L18.0535 209.229",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45215 210.257L10.9404 220.355C10.9404 220.355 11.0486 221.438 12.8607 221.438L22.9219 221.303",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3567 230.238L13.8343 230.752L13.2393 229.507L16.566 227.584L25.1937 227.341",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2393 229.506L25.924 229.154",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96582 210.067L10.0206 214.264L14.0235 215.049L20.4605 214.697",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0205 214.264L19.9465 213.804",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0234 215.049L15.0782 218.785C15.0782 218.785 14.9701 219.678 16.8633 219.678L22.2185 219.57",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.376 222.576L16.566 227.585",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2148 230.59L18.2697 232.539C18.2697 232.539 18.3778 232.918 19.4867 232.918L26.681 232.647",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69141 237.954L10.7782 237.602C10.7782 237.602 12.2928 237.493 13.564 238.847",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69141 236.14L8.26294 235.95C8.26294 235.95 9.75049 235.896 11.3192 233.893",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7529 239.063L62.3822 238.576",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28711 218.162L6.09921 218",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4522 129.308L82.6665 131.392C82.6665 131.392 65.7896 137.186 61.8408 139.352L70.3063 139.487C70.3063 139.487 72.4971 139.568 74.7419 138.756L91.5376 133.071L98.7861 130.607L101.031 129.687",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.667 131.393L92.3225 131.907C92.3225 131.907 93.4314 131.988 92.8094 132.719",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4307 131.879L97.2178 129.659",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9361 200.917C43.9368 191.523 49.292 179.718 49.292 179.718C51.9696 173.762 56.4592 167.508 56.4592 167.508C59.9482 163.068 58.6229 161.227 58.6229 161.227C57.6222 158.52 53.7276 158.899 53.7276 158.899C46.4251 159.44 41.9354 161.065 41.9354 161.065C33.7944 163.15 23.7062 170.784 23.7062 170.784L20.3795 175.278C20.3795 175.278 13.5909 185.945 13.2393 193.824",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5732 199.59L82.6665 200.185",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6787 170.757L29.5478 169.485L58.5143 163.935",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.25 167.725L58.7582 162.202",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.793 165.505L58.3254 160.849",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2285 163.23L57.4058 159.684",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1377 172.869L28.3042 171.732L29.9811 171.488L57.1086 166.507",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.457 185.187L24.5175 183.265L47.8855 182.913",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0283 202.921L21.3529 194.907L24.1927 192.2L24.328 185.052L24.5173 183.184L28.0333 171.732L29.007 169.539",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9434 186.135L24.3284 185.052L47.2637 184.348",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77331 218.189L4.58398 218.596L4.66512 219.218H6.45018",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96285 219.272L4.69238 219.679H6.55858",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66735 223.875L5.50365 224.2L5.125 224.687L5.20614 225.31L8.15418 225.039",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.125 224.688L7.91077 224.336",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69574 229.588L6.15268 230.156L5.82812 230.698L6.01745 231.375L10.1555 230.698",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82812 230.698L9.85802 230.048",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80078 235.084L5.42285 234.786L10.6969 234.597",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93643 224.092L5.39551 219.733",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69365 230.048L6.09863 225.229",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28919 234.731L6.85645 231.293",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09668 218.406L4.31376 234.786",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96094 209.499L4.55738 209.932",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69043 205.384L4.71961 205.465",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04415 203.598L7.15376 203.733L5.88259 204.545C4.44913 205.222 4.69255 206.143 4.69255 206.143L4.53027 209.906L6.36942 218.623C7.72174 225.284 11.8869 235.219 11.8869 235.219C13.9694 241.338 17.6748 242.611 17.6748 242.611",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96289 201.864L7.18069 201.647",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74609 198.318L7.39734 197.668L21.3532 194.907L44.3426 193.58",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.374 173.735L10.0203 175.035L5.82812 192.091L6.7477 192.578",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7783 189.248L7.53202 190.493L6.80177 190.981C6.80177 190.981 6.42313 191.685 6.85587 193.147L7.07224 193.742L7.93772 194.175L11.2374 193.661L13.0495 193.607",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53223 190.494L13.6717 190.358",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69434 196.395L8.80323 196.179",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9982 170.08L15.5654 171.434",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2151 173.275L16.376 177.147",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4835 179.204L13.5361 183.698",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7247 186.081L11.6699 190.386",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.066 137.186L157.233 135.886C150.255 135.183 151.013 129.362 151.013 129.362L154.745 100.745L149.85 106.052",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.246 120.807L117.936 142.303C117.368 143.494 119.505 143.007 119.505 143.007L135.651 139.866",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.952 103.182L140.005 104.346C140.005 104.346 138.734 110.763 138.518 119.643L138.247 132.476C138.247 132.476 137.923 135.806 139.167 136.212L140.249 136.564C140.249 136.564 140.979 138.242 144.441 138.242C144.441 138.242 145.55 138.351 147.172 137.213C147.172 137.213 149.688 137.295 150.905 135.86C150.905 135.86 152.284 134.642 152.257 133.396L149.985 108.299C149.985 108.299 149.931 106.431 149.417 104.698C149.147 103.832 148.687 103.02 148.092 102.343C148.092 102.343 147.876 102.072 147.605 101.964C147.254 101.828 146.577 101.666 145.252 101.666L142.926 102.045C142.169 102.18 141.493 102.559 141.006 103.155L140.952 103.182Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.734 105.699C139.734 105.699 136.705 110.193 136.245 120.265L135.65 139.866",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.678 139.866L141.817 140.462H145.279C145.279 140.462 148.362 140.408 149.796 139.731L150.093 136.563",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.572 135.508L143.711 134.1C143.711 134.1 144.468 134.019 144.766 133.585C144.982 133.288 145.253 133.017 145.631 132.854C146.145 132.611 146.848 132.394 147.443 132.719C147.443 132.719 148.417 133.071 148.282 135.535C148.282 135.535 148.147 136.563 147.173 137.213",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.248 136.536C140.248 136.536 140.491 135.751 143.899 135.047C143.899 135.047 145.522 134.722 145.765 134.045C145.82 133.883 145.901 133.721 146.036 133.585C146.415 133.152 147.145 132.556 147.415 133.964C147.415 133.964 148.578 137.673 143.331 138.161",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.465 103.696H141.439C141.439 103.696 142.71 103.669 142.845 105.564L142.547 121.971C142.547 121.971 142.196 123.839 145.414 123.812L147.443 123.595C147.443 123.595 149.201 123.676 149.228 120.969L147.848 107.513C147.848 107.513 147.497 101.557 145.198 101.666",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.228 121.43L150.039 132.367C150.039 132.367 150.309 135.129 148.93 136.185C148.93 136.185 148.037 136.834 147.361 137.132",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.308 124.543L144.71 124.678L140.978 125.193C140.978 125.193 139.923 127.223 140.113 129.037L141.113 131.284C141.221 131.528 141.465 131.636 141.708 131.609L145.008 131.068H149.876L149.335 124.543H149.308Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6 125.491L140.817 125.328",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.734 131.907L141.411 131.663",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.383 133.531C138.383 133.531 138.734 133.694 139.654 133.342L139.519 119.291L139.897 113.253L141.033 103.805",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8096 242.096L62.5448 247.917",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5068 249.568L48.4805 252.465C48.4805 252.465 48.4805 254.198 50.6172 254.116L54.4036 254.008C54.4036 254.008 55.9453 254.116 56.4321 251.382L57.1083 249.433L47.5339 249.541L47.5068 249.568Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.154 8.28906H570.528",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.154 7.96412H266.528C226.58 7.96412 196.748 31.6805 196.748 31.6805L165.942 57.1025L165.807 59.0247L164.049 60.4325L97.1637 129.605L91.4569 129.47L86.21 129.28C86.0477 129.334 85.9395 129.334 85.8313 129.334H85.4527C85.074 129.226 84.9117 128.983 84.9117 128.983C82.0178 131.094 80.2057 131.5 80.2057 131.5C66.8719 135.345 43.9096 146.878 43.9096 146.878L29.4127 154.188C16.5658 160.794 14.348 168.862 14.348 168.862L13.9152 170.378L13.1579 171.677C13.0227 171.677 12.8875 171.759 12.8063 171.867L12.022 172.896L11.8327 173.897L10.0206 175.062L5.82838 192.118L6.74796 192.605C6.775 192.795 6.80205 192.957 6.85614 193.174L7.07251 193.769L7.93799 194.203L8.39778 194.121L7.69458 196.423L5.04404 197.126L4.71949 197.343L3.74582 198.318L3.52945 198.859L3.12375 201.458C3.1508 201.729 3.39422 201.918 3.66468 201.918H5.01699L5.09813 203.597L2.36646 204.815C1.47393 205.276 1.55507 206.034 1.55507 206.034L1.50098 209.012L2.01486 209.472V212.017C2.01486 212.531 2.42055 212.964 2.96148 212.964H4.34084V218.135L1.90667 218.569L2.33941 227.232L3.06966 234.217L4.85472 235.056L2.74511 236.112V237.899L36.1202 248.485L37.4996 249.432H47.5338L48.5345 252.438C48.5345 252.438 48.5345 254.17 50.6711 254.089L54.4576 253.981C54.4576 253.981 55.9993 254.089 56.4861 251.355L57.1622 249.405H62.9772C62.0306 245.561 62.1388 241.283 62.5985 237.385L71.7672 240.065C71.4427 242.123 71.2263 244.234 71.2263 246.373C71.2263 268.032 88.7794 285.603 110.416 285.603C126.59 285.603 140.492 275.775 146.469 261.778L158.288 265.216C158.505 265.379 158.748 265.487 159.019 265.541L160.263 265.785L160.317 267.138C160.317 267.626 160.804 267.978 161.29 267.869L164.482 267.03C164.671 266.976 164.806 266.814 164.806 266.624V265.054L164.942 250.976H169.134L252.707 250.136H444.6L459.07 252.356C461.964 271.172 478.165 285.63 497.773 285.63C513.217 285.63 526.551 276.641 532.934 263.646L548.702 266.055L550.297 266.759H551.677V249.622L607.365 241.581L611.557 241.825C612.504 241.879 613.423 241.771 614.316 241.473L622.781 238.738C624.458 237.899 624.458 236.627 624.458 236.627L625.729 229.317C625.729 226.772 624.242 226.88 624.242 226.88L620.861 226.447V224.714L629.056 219.056C629.597 218.65 629.895 218.027 629.895 217.377V207.441C629.895 205.979 629.218 204.599 628.055 203.705L623.106 199.861L624.35 195.827L624.053 168.402L624.107 168.456L624.053 168.185V164.855C624.053 164.855 624.053 164.855 624.053 164.828L623.782 140.597L622.132 116.854C622.322 106.403 619.103 76.5683 617.589 63.3835L617.345 60.3783H617.237C616.993 58.2666 616.831 56.9942 616.831 56.9942L617.264 56.6422C617.94 56.0737 618.238 55.2073 618.075 54.368L614.803 36.8786L614.749 36.7161C614.451 35.8498 614.478 34.9022 614.776 34.0629L615.29 32.628C615.29 25.8326 607.717 12.8644 607.717 12.8644C604.66 10.7798 595.302 9.37194 595.302 9.37194H592.381C585.214 7.96412 574.963 7.90997 570.528 7.93704L349.154 7.99119V7.96412Z",
    stroke: "#808184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.332 184.457V186.867",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.387 184.457V186.867",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.387 184.457C334.387 184.159 334.144 183.942 333.873 183.942C333.603 183.942 333.359 184.186 333.359 184.457",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.682 181.506H337.01",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.682 181.506V202.65",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.872 205.086C332.574 204.599 331.925 203.11 331.925 203.11L331.871 203.002L331.817 202.921L331.763 202.839L331.682 202.785",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.253 202.785L334.172 202.839L334.09 202.921L334.009 203.002L333.928 203.11L333.874 203.218C333.874 203.218 333.171 204.599 332.9 205.086",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.01 181.506V202.65",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.011 181.506C337.011 181.506 336.93 181.289 336.795 181.289",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.898 181.289C330.898 181.289 330.682 181.37 330.682 181.506",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.898 181.289H336.795",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.613 205.791H312.21",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.953 202.65C331.197 202.65 331.467 202.705 331.683 202.786",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.209 205.791H333.008",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.932 205.791H333.008",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.252 202.786C334.441 202.705 334.685 202.65 334.901 202.65",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.932 205.791H344.096",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.786 205.791H344.098",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.47,
    cy: 202.651,
    rx: 0.378648,
    ry: 0.379029,
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.785 205.791H363.408",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.521 181.289V173.898",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.172 181.289V173.898",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.209 202.65H330.872",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.182 202.65H311.21",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.29 202.65H311.182",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.871 202.65H330.952",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.952 202.65H311.289",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.612 205.791L309.152 205.547L310.234 203.273C310.396 202.894 310.748 202.623 311.181 202.623",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.682 202.65H311.209",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.182 202.65H311.29",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.21 202.65H311.182",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.289 202.65H330.681",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.419 202.65H334.9",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.555 202.65H342.42",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 342.554,
    cy: 202.651,
    rx: 0.378648,
    ry: 0.379029,
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.9 202.65H335.036",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.037 202.65H342.556",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.01 202.65H342.419",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 342.554,
    cy: 202.651,
    rx: 0.378648,
    ry: 0.379029,
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.42 202.65H342.555",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 342.554,
    cy: 202.651,
    rx: 0.378648,
    ry: 0.379029,
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.554 202.65H337.01",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.84 203.463L363.895 205.575",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.785 202.65H337.471",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.408 205.791L363.895 205.574",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.866 202.65H361.785",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.785 202.65H361.866",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.841 203.463C362.732 203.002 362.327 202.65 361.84 202.65",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.471 202.65H361.785",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.631 191.064C334.631 191.064 334.631 191.064 334.631 191.036",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.631 191.062V191.09L334.604 191.117L334.577 191.144L334.496 191.171L334.442 191.198L334.388 191.225L334.334 191.252L334.253 191.279H334.09L333.928 191.306H333.766L333.603 191.279H333.495L333.414 191.252L333.306 191.225L333.252 191.198L333.198 191.171L333.144 191.144L333.117 191.117L333.09 191.09L333.062 191.062",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.062 191.036C333.062 191.036 333.062 191.036 333.062 191.064",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.062 187.056V187.029L333.09 187.002V186.975L333.117 186.948L333.171 186.921L333.225 186.893L333.279 186.866H333.333L333.414 186.839L333.549 186.812L333.712 186.785H333.874L334.063 186.812L334.225 186.839L334.361 186.866H334.415L334.469 186.893L334.523 186.921L334.577 186.948L334.604 186.975L334.631 187.002V187.029V187.056",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.901 189.547V189.736V189.899L334.874 190.088L334.847 190.251L334.793 190.494L334.739 190.738L334.658 190.982L334.631 191.063",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.791 189.547V189.736L332.818 189.899V190.088L332.845 190.251L332.899 190.494L332.953 190.738L333.034 190.982L333.061 191.063",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.061 187.056L333.007 187.381L332.953 187.705L332.899 188.03L332.872 188.355L332.818 188.788V189.086L332.791 189.384V189.546",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.631 187.056L334.712 187.381L334.766 187.705L334.793 188.03L334.847 188.355L334.874 188.788L334.901 189.086V189.384V189.546",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.865 206.197V210.123",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.084 206.197V210.123",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.865 210.122H364.084",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.029 210.122V211.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.002 211.882V210.122",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.918 211.882V210.122",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.92 210.122V211.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.865 206.197H361.001H362.786H364.084",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.029 211.882H364.003",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.112 206.685C364.112 206.685 364.112 206.657 364.084 206.657",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.002 211.882C364.002 211.882 364.083 211.882 364.11 211.828",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.652 209.257C364.652 208.363 364.463 207.497 364.111 206.685",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.111 211.828C364.463 211.016 364.652 210.149 364.652 209.256",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.918 211.882H360.919",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.866 206.63C359.866 206.63 359.866 206.63 359.838 206.658",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.838 211.828C359.838 211.828 359.892 211.882 359.946 211.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.838 206.685C359.486 207.497 359.297 208.363 359.297 209.257",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.297 209.256C359.297 210.149 359.486 211.016 359.838 211.828",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5 206.197V210.123",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.691 206.197V210.123",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5 210.122H344.692",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.637 210.122V211.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.637 211.882V210.122",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.553 211.882V210.122",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.527 210.122V211.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5 206.197H341.609H343.421H344.692",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.637 211.882H344.637",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.72 206.685C344.72 206.685 344.72 206.657 344.691 206.657",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.637 211.882C344.637 211.882 344.718 211.882 344.745 211.828",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.287 209.257C345.287 208.363 345.098 207.497 344.746 206.685",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.719 211.828C345.07 211.016 345.26 210.149 345.26 209.256",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.553 211.882H341.526",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.501 206.63C340.501 206.63 340.501 206.63 340.473 206.658",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.445 211.828C340.445 211.828 340.499 211.882 340.554 211.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.445 206.685C340.094 207.497 339.904 208.363 339.904 209.257",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.904 209.256C339.904 210.149 340.094 211.016 340.445 211.828",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.125 206.197V210.123",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.346 206.197V210.123",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.125 210.122H313.344",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.291 210.122V211.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.291 211.882V210.122",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.207 211.882V210.122",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.182 210.122V211.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.125 206.197H310.261H312.073H313.344",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.291 211.882H313.292",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.374 206.685C313.374 206.685 313.374 206.657 313.346 206.657",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.291 211.882C313.291 211.882 313.372 211.882 313.399 211.828",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.939 209.257C313.939 208.363 313.75 207.497 313.398 206.685",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.373 211.828C313.725 211.016 313.914 210.149 313.914 209.256",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.207 211.882H310.181",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.128 206.63C309.128 206.63 309.128 206.63 309.1 206.658",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1 211.828C309.1 211.828 309.154 211.882 309.208 211.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1 206.685C308.748 207.497 308.559 208.363 308.559 209.257",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.559 209.256C308.559 210.149 308.748 211.016 309.1 211.828",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.993 158.954L311.75 159.144L311.533 159.387L311.317 159.604L311.128 159.848L310.938 160.091L310.776 160.362L310.587 160.606L310.451 160.849L310.343 161.12L310.208 161.364L310.1 161.689L309.965 161.986L309.883 162.311L309.802 162.636L309.721 162.961L309.667 163.286L309.64 163.638L309.613 163.963L309.586 164.288V164.64L309.613 164.937L309.64 165.262L309.694 165.56L309.748 165.858L309.802 166.156L309.883 166.453L309.965 166.751L310.073 167.049L310.208 167.347L310.343 167.645L310.478 167.915L310.641 168.186L310.803 168.457L310.992 168.701L311.182 168.971L311.398 169.215L311.614 169.459L311.858 169.702L312.101 169.919L312.372 170.135L312.642 170.352L312.913 170.542L313.21 170.704L313.508 170.866L313.778 171.002L314.022 171.11L314.292 171.218L314.562 171.327L314.86 171.408L315.13 171.489L315.428 171.543L315.725 171.597L316.023 171.652L316.348 171.679L316.699 171.706H317.051H317.402L317.754 171.679H317.97L318.187 171.652L318.403 171.624L318.592 171.597L319.025 171.516V170.217L318.809 170.271L318.592 170.298L318.403 170.325L318.187 170.352L317.889 170.406L317.619 170.433H317.321H316.997H316.645L316.32 170.406L316.131 170.379L315.969 170.352L315.807 170.325L315.644 170.298L315.374 170.244L315.13 170.163L314.86 170.081L314.589 169.973L314.319 169.865L314.076 169.729L313.832 169.594L313.562 169.459L313.345 169.269L313.102 169.107L312.886 168.917L312.669 168.728L312.453 168.511L312.264 168.267L312.074 168.024L311.885 167.78L311.723 167.536L311.56 167.266L311.425 166.995L311.317 166.697L311.209 166.453L311.128 166.21L311.073 165.966L310.992 165.668L310.938 165.398L310.911 165.1L310.884 164.802L310.857 164.504V164.206L310.884 163.909L310.911 163.611L310.938 163.313L310.992 163.042L311.073 162.744L311.155 162.447L311.263 162.176L311.344 161.932L311.452 161.716L311.56 161.472L311.723 161.228L311.858 160.985L312.047 160.741L312.209 160.524L312.399 160.308",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.488 167.779H327.517",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.176 167.779H341.258",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.674 165.343C321.377 166.832 322.865 167.779 324.487 167.779",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.518 167.779H340.175",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.258 167.779C343.584 167.833 345.504 165.992 345.558 163.664C345.558 163.014 345.45 162.364 345.152 161.796",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.675 165.343L315.779 154.865",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.518 168.294V167.779",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.176 168.294V167.779",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.518 168.294H340.175",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.066 150.832L345.151 161.77",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.053 148.098C317.43 148.098 315.32 150.236 315.32 152.836C315.32 153.539 315.483 154.216 315.78 154.839",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.517 168.294H319.078",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.614 168.294H340.176",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.066 150.832C339.282 149.154 337.605 148.098 335.766 148.098",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.053 148.098H335.767",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.078 171.272V168.294",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.613 171.272H319.078",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.613 171.272V168.294",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.736 171.272V173.899",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.955 171.272V173.899",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.956 173.898H331.736",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.773 163.556C343.773 163.204 343.692 162.852 343.557 162.527",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.555 162.528L338.443 151.59",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.284 165.993H324.488",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.283 165.993C342.636 166.02 343.744 164.964 343.799 163.637C343.799 163.258 343.744 162.879 343.582 162.527",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 164.585C322.675 165.451 323.541 165.993 324.46 165.993",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.443 151.59L343.555 162.528",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 164.585L317.375 154.107",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.443 151.589C337.956 150.561 336.902 149.884 335.766 149.884",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.054 149.884C318.431 149.884 317.105 151.21 317.105 152.835C317.105 153.268 317.214 153.701 317.376 154.08",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.053 149.884H335.767",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.152 135.752L315.13 154.893",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.916 160.551L315.131 154.893",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.153 135.751L308.287 132.963",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.264 163.014C314.237 163.827 315.698 163.691 316.509 162.69C316.996 162.094 317.158 161.282 316.915 160.551",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.265 163.014L311.047 155.948",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.068 136.808L311.046 155.949",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.288 132.963C307.909 131.745 306.611 131.068 305.421 131.447C304.691 131.691 304.096 132.259 303.906 133.017",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.069 136.808L303.879 133.018",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.029 163.557H343.773",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.992 163.557H345.557",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.028 163.557H321.811",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.264 167.78C352.318 167.076 352.616 165.668 351.94 164.585C351.507 163.936 350.804 163.557 350.02 163.557",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.265 167.779H343.881",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.84 167.779H324.489",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.258 167.779H343.881",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.84 167.781C323.84 167.781 323.84 167.753 323.84 167.726",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.972 163.881C318.863 164.531 318.512 165.938 319.134 167.021C319.323 167.319 319.566 167.59 319.864 167.779",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.839 167.779H319.863",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.292 136.969V211.881H420.854V136.969",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.854 128.522H429.292",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.07 136.97C421.07 136.97 420.881 136.888 420.881 136.78V128.739C420.881 128.739 420.962 128.55 421.07 128.55",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.854 28.2422V128.522",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.293 28.2422V128.522V136.969",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.854 28.2422H429.292",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.854 136.969H429.292L420.854 128.522",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.799 167.562C420.501 167.562 420.285 167.806 420.285 168.077V175.468C420.285 175.766 420.529 175.982 420.799 175.982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.359 132.584V131.176",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.359 130.092V128.685",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.359 128.522H420.853",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.556 126.925H368.465",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.465 126.925C368.303 126.925 368.141 127.06 368.141 127.25",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.141 127.25V128.198",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.141 128.197C368.141 128.36 368.276 128.522 368.465 128.522H372.36",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.557 128.522C420.719 128.522 420.881 128.387 420.881 128.197",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.854 128.198V127.25",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.854 127.25C420.854 127.087 420.719 126.925 420.529 126.925",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.853 168.618H372.359",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.359 172.842H420.853",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.854 168.618V172.842",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.359 172.842V168.618",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.853 128.522H372.359",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.359 132.746H420.853",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.359 132.746V128.522",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.359 132.746V211.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.36 132.746H368.141V211.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.141 211.882H372.36",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.854 127.25C420.854 127.087 420.719 126.925 420.529 126.925",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.557 128.522C420.719 128.522 420.881 128.387 420.881 128.197",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.141 132.746V128.252",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M580.237 166.642H438.027V211.881H580.237V166.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.359 211.883H446.17",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.169 211.883H437.92V166.508",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.359 211.72V211.882",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.647 144.361H436.865V207.686H471.647V144.361Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.838 144.361H434.215V207.686H436.838V144.361Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.291 149.613H444.223C443.939 149.613 443.709 149.844 443.709 150.128V159.658C443.709 159.942 443.939 160.172 444.223 160.172H464.291C464.575 160.172 464.805 159.942 464.805 159.658V150.128C464.805 149.844 464.575 149.613 464.291 149.613Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.017 179.178H449.496C449.212 179.178 448.982 179.408 448.982 179.692V199.781C448.982 200.065 449.212 200.295 449.496 200.295H459.017C459.3 200.295 459.53 200.065 459.53 199.781V179.692C459.53 179.408 459.3 179.178 459.017 179.178Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.92 166.508H446.358",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.359 166.508V211.72",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.709 174.954V203.462",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.146 174.954V203.462",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.01 174.954V203.462",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.449 174.954V203.462",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.827 211.883H446.359",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.359 203.463H482.71H482.899H484.278H484.386H485.279H485.387H488.497H488.606H489.498H489.579H490.986H491.148H527.011H527.174H528.58H528.688H529.554H529.662H532.799H532.88H533.773H533.881H535.261H535.45H571.827",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.359 174.954H571.827",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.827 166.508H536.288H533.34H484.819H481.871H446.359",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.238 211.883V166.508H571.988L571.826 166.67V211.883H571.988H580.238Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.695 60.0003L537.858 63.2221L545.052 62.7618H545.701L545.458 59.3506C545.458 59.3506 539.318 59.5401 537.695 60.0003Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.402 59.4045C544.402 59.4045 544.564 59.4045 544.618 59.3233L544.429 56.995C544.212 56.8325 541.373 57.0491 541.373 57.0491C539.858 57.1304 538.316 57.374 538.316 57.374L538.506 59.7565C538.506 59.7565 538.641 59.8106 538.722 59.7836L544.402 59.3774V59.4045Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.64 57.3739L538.586 55.3705L540.317 55.208H543.752L543.779 56.9678",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.64 56.7783L526.226 56.1826L525.631 55.6953H538.64",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.781 56.7783L556.087 56.1826L556.682 55.6953H543.727",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.829 62.9507L534.935 63.2485L534.827 63.1943L534.718 63.1402L534.583 63.0319L534.475 62.8695L534.367 62.707L534.286 62.5175L534.232 62.3009L534.177 62.0843L534.15 61.8677V61.6241V61.4075L534.204 61.1909L534.259 61.0014L534.313 60.8389L534.421 60.7036L534.529 60.5682L534.637 60.5141L534.745 60.4599H534.772L537.234 60.2163L537.612 60.1621",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.008 64.4943L534.72 63.1406",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.476 60.623L521.142 62.0309C521.142 62.0309 520.358 63.3033 521.358 64.5487",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.412 64.5484L534.719 63.1406",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.357 64.5484L534.718 63.1406",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.899 64.4938C521.899 64.4938 521.845 64.6021 521.818 64.6562C521.791 64.7104 521.737 64.7645 521.683 64.8187C521.656 64.8728 521.602 64.8999 521.548 64.954C521.494 65.0082 521.467 65.0352 521.413 65.0623C521.386 65.0623 521.331 65.1165 521.277 65.1165C521.007 65.2518 520.574 65.3872 520.574 65.3872C520.574 65.3872 520.547 65.3872 520.52 65.3872H520.466L518.762 65.5496H518.6C517.869 65.6038 517.247 64.7374 517.166 63.6274C517.085 62.5174 517.626 61.5698 518.356 61.5157H518.437L520.141 61.3262H520.195C520.195 61.3262 520.222 61.3262 520.25 61.3262C520.25 61.3262 520.709 61.3803 520.98 61.4615C521.034 61.4615 521.061 61.4615 521.115 61.4886C521.169 61.4886 521.223 61.5428 521.277 61.5698C521.331 61.5969 521.386 61.624 521.413 61.6781C521.467 61.7323 521.521 61.7593 521.575 61.8135C521.602 61.8676 521.656 61.8947 521.683 61.9489",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.951 60.0003L479.789 63.2221L472.594 62.7618H471.945L472.189 59.3506C472.189 59.3506 478.328 59.5401 479.951 60.0003Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.244 59.4045C473.244 59.4045 473.081 59.4045 473.027 59.3233L473.217 56.995C473.433 56.8325 476.273 57.0491 476.273 57.0491C477.787 57.1304 479.329 57.374 479.329 57.374L479.14 59.7565C479.14 59.7565 479.005 59.8106 478.923 59.7836L473.244 59.3774V59.4045Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.977 57.3739L479.031 55.3705L477.327 55.208H473.892L473.838 56.9678",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.004 56.7783L491.391 56.1826L492.013 55.6953H479.004",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.839 56.7783L461.56 56.1826L460.965 55.6953H473.893",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.789 62.9507L482.71 63.2485L482.791 63.1943L482.926 63.1402L483.035 63.0319L483.143 62.8695L483.251 62.707L483.332 62.5175L483.413 62.3009L483.44 62.0843L483.467 61.8677L483.494 61.6241L483.467 61.4075L483.44 61.1909L483.386 61.0014L483.305 60.8389L483.224 60.7036L483.116 60.5682L483.008 60.5141L482.872 60.4599H482.845L480.411 60.2163L480.032 60.1621",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.637 64.4943L482.898 63.1406",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.168 60.623L496.502 62.0309C496.502 62.0309 497.286 63.3033 496.285 64.5487",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.232 64.5484L482.898 63.1406",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.259 64.5484L482.898 63.1406",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.719 64.4938C495.719 64.4938 495.773 64.6021 495.8 64.6562C495.827 64.7104 495.881 64.7645 495.935 64.8187C495.962 64.8728 496.016 64.8999 496.07 64.954C496.124 65.0082 496.151 65.0352 496.206 65.0623C496.233 65.0623 496.287 65.1165 496.341 65.1165C496.611 65.2518 497.044 65.3872 497.044 65.3872C497.044 65.3872 497.071 65.3872 497.098 65.3872H497.152L498.856 65.5496H499.018C499.749 65.6038 500.371 64.7374 500.452 63.6274C500.533 62.5174 499.992 61.5698 499.262 61.5157H499.181L497.477 61.3262H497.423C497.423 61.3262 497.396 61.3262 497.369 61.3262C497.369 61.3262 496.909 61.3803 496.638 61.4615C496.584 61.4615 496.557 61.4615 496.503 61.4886C496.449 61.4886 496.395 61.5428 496.341 61.5698C496.287 61.5969 496.233 61.624 496.206 61.6781C496.151 61.7323 496.097 61.7593 496.043 61.8135C496.016 61.8676 495.962 61.8947 495.935 61.9489",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.032 57.9696L517.951 56.4806V56.3993C517.951 56.3993 517.924 56.0745 517.14 55.9391C517.14 55.9391 514.489 55.4247 510.027 55.3164H509.324C503.887 55.3164 500.561 55.9391 500.561 55.9391C499.776 56.0203 499.749 56.3993 499.749 56.3993V56.4806L499.668 57.8884",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.427 57.0225C503.157 57.0225 503.292 61.9228 503.238 62.0311V64.6301C503.211 65.1445 503.373 66.0379 502.805 66.2816C502.697 66.2816 501.236 66.6065 501.236 66.6065",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.219 57.0225C514.489 57.0225 514.354 61.9228 514.408 62.0311V64.6301C514.435 65.1445 514.273 66.0379 514.841 66.2816C514.949 66.2816 516.409 66.6065 516.409 66.6065",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.435 62.0576H503.238",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.248 65.4961V66.1188C518.221 66.2812 518.113 66.3895 517.951 66.4166L516.653 66.579C516.653 66.579 509.81 66.579 508.836 66.579C507.863 66.579 501.02 66.579 501.02 66.579L499.722 66.4166C499.559 66.4166 499.451 66.2541 499.451 66.1188V65.4961",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.153 65.4424L496.531 67.1209",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.506 67.825L499.128 66.1464C499.128 66.1464 499.263 65.7132 499.425 65.7674",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.449 67.8513H495.53C495.53 67.8513 495.639 67.9325 495.72 67.9596L495.99 68.0679L496.396 68.2033L496.856 68.3657L497.315 68.5282L497.775 68.6906L498.208 68.853L498.587 68.9884L498.938 69.1238L499.317 69.2591L499.668 68.2574L499.29 68.1221L498.938 67.9867L498.56 67.8513L498.127 67.6889L497.667 67.5264L497.207 67.364L496.747 67.2016L496.342 67.0662L496.071 66.9579L495.882 66.8767H495.801V66.8496L495.449 67.8243",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.656 58.7012V45.7871",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.033 45.7871V58.7012",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.467 44.7852L520.035 45.7869H520.359H520.684L521.225 44.7852",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.279 44.785C522.414 44.785 522.549 44.7309 522.684 44.6767C522.82 44.6226 522.928 44.5413 523.036 44.4601C523.144 44.3789 523.252 44.2706 523.306 44.1352C523.361 43.9999 523.442 43.8916 523.469 43.7562C523.469 43.7562 523.469 43.7021 523.469 43.675C523.469 43.6479 523.469 43.675 523.469 43.6479C522.468 43.296 521.413 43.1064 520.358 43.1064C519.304 43.1064 518.249 43.296 517.248 43.6479C517.248 43.6479 517.248 43.6479 517.248 43.675C517.248 43.7021 517.248 43.675 517.248 43.7021C517.302 43.8645 517.356 43.9999 517.41 44.1352C517.464 44.2706 517.573 44.3518 517.681 44.4601C517.789 44.5684 517.924 44.6226 518.032 44.6767C518.141 44.7309 518.303 44.7579 518.438 44.785H522.279Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.143 61.5161V60.2437L520.845 58.8088C520.845 58.8088 520.791 58.7275 520.737 58.7275H519.953C519.953 58.7275 519.871 58.7546 519.844 58.8088L519.547 60.2437V61.3807",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.248 65.9561C518.248 65.9561 518.383 65.9561 518.464 66.0102C518.546 66.0644 518.573 66.1456 518.573 66.1727L519.141 67.7429L519.573 68.9342L520.547 68.5822L521.548 68.2302L521.385 67.7971L521.25 67.418L520.547 65.4688",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.544 69.8008H513.758V72.6164L513.163 73.212H508.836H504.536L503.914 72.6164V69.8008H501.02",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.75 74.8633V75.6484L502.237 76.7584H502.345H506.294H506.943H510.729H511.378H515.354H515.435L515.922 75.6484L515.435 76.7584L515.922 75.6484V74.8633",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.066 93.1387L486.471 94.7901",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.443 95.4933L489.065 93.8418",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.204 94.7901L530.609 93.1387",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.635 93.8418L529.23 95.4933",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.656 68.8809L528.717 93.7884",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.475 93.1383L521.441 68.2578",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.288 68.1494L487.174 93.1653",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.959 93.8147L498.047 68.7988",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.064 96.9823C486.578 97.5779 487.471 97.6321 488.066 97.1177C488.661 96.6033 488.715 95.7099 488.201 95.1143",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.201 95.0876C487.687 94.4919 486.794 94.4378 486.199 94.9522C485.604 95.4666 485.55 96.36 486.064 96.9556",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.473 96.9823C529.987 97.5779 530.879 97.6321 531.474 97.1177C532.069 96.6033 532.123 95.7099 531.609 95.1143",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.611 95.0876C531.097 94.4919 530.205 94.4378 529.61 94.9522C529.015 95.4666 528.96 96.36 529.474 96.9556",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.064 93.1387L488.065 93.4906L489.066 93.8426",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.609 93.4906L530.61 93.1387",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.635 93.8422L529.608 93.4902",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.868 86.1807V87.5073C513.786 87.6968 513.705 87.8592 513.597 88.0487C513.489 88.2382 513.408 88.4007 513.3 88.5631C513.164 88.7797 513.002 88.9692 512.84 89.1587C512.677 89.3483 512.488 89.5107 512.299 89.6731",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.834 86.1807V87.5343C503.942 87.7509 504.05 87.9946 504.186 88.2112C504.321 88.4278 504.456 88.6444 504.618 88.8339C504.726 88.9963 504.862 89.1317 504.997 89.267C505.132 89.4024 505.267 89.5378 505.43 89.6731",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.403 80.793C505.213 80.9554 505.024 81.1449 504.862 81.3074C504.699 81.4698 504.537 81.6864 504.402 81.903C504.294 82.0654 504.186 82.2279 504.104 82.4174C504.023 82.6069 503.915 82.7693 503.834 82.9588V84.2854",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.891 82.1191H509.784",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.078 85.2333C508.078 85.2333 508.078 85.125 508.078 85.0979C508.078 85.0708 508.078 84.9896 508.133 84.9625C508.187 84.9354 508.187 84.8813 508.214 84.8272C508.241 84.773 508.268 84.7459 508.295 84.7189C508.322 84.6918 508.376 84.6647 508.403 84.6376C508.43 84.6106 508.484 84.5835 508.538 84.5564C508.592 84.5293 508.619 84.5293 508.673 84.5023C508.728 84.4752 508.782 84.5023 508.809 84.5023C508.836 84.5023 508.917 84.5023 508.944 84.5023C508.971 84.5023 509.052 84.5023 509.079 84.5564C509.106 84.6106 509.16 84.6106 509.214 84.6376C509.268 84.6647 509.296 84.6918 509.323 84.7189C509.35 84.7459 509.377 84.8001 509.404 84.8272C509.431 84.8542 509.458 84.9084 509.485 84.9625C509.512 85.0167 509.512 85.0437 509.539 85.0979C509.566 85.152 509.539 85.2062 509.539 85.2333C509.539 85.2874 509.539 85.3415 509.539 85.3686C509.539 85.3957 509.539 85.4769 509.485 85.504C509.431 85.5311 509.431 85.5852 509.404 85.6394C509.377 85.6935 509.35 85.7206 509.323 85.7476C509.296 85.7747 509.241 85.8018 509.214 85.8289C509.187 85.8559 509.133 85.883 509.079 85.9101C509.025 85.9372 508.998 85.9372 508.944 85.9642C508.89 85.9913 508.836 85.9642 508.809 85.9642C508.782 85.9642 508.7 85.9642 508.673 85.9642C508.646 85.9642 508.565 85.9642 508.538 85.9101C508.511 85.8559 508.457 85.8559 508.403 85.8289C508.349 85.8018 508.322 85.7747 508.295 85.7476C508.268 85.7206 508.241 85.6664 508.214 85.6394C508.187 85.6123 508.16 85.5581 508.133 85.504C508.105 85.4498 508.105 85.4228 508.078 85.3686C508.051 85.3145 508.078 85.2603 508.078 85.2333Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 510.947,
    cy: 85.2335,
    rx: 0.378648,
    ry: 0.379029,
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 506.726,
    cy: 85.2335,
    rx: 0.378648,
    ry: 0.379029,
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.89 78.3291V81.9028V82.6879C507.89 82.7692 507.89 82.8774 507.863 82.9587C507.836 83.0399 507.809 83.1211 507.782 83.2023C507.755 83.2835 507.701 83.3648 507.646 83.446C507.592 83.5272 507.538 83.5814 507.457 83.6355C507.349 83.7438 507.241 83.8521 507.16 83.9604C507.078 84.0687 506.997 84.204 506.943 84.3394C506.889 84.4748 506.835 84.6101 506.808 84.7726C506.781 84.935 506.781 85.0704 506.754 85.2328C506.754 85.3682 506.754 85.5036 506.781 85.6389C506.808 85.7743 506.835 85.9097 506.889 86.045C506.943 86.1804 506.997 86.2887 507.078 86.397C507.16 86.5053 507.241 86.6136 507.349 86.7219C507.457 86.8302 507.565 86.9114 507.674 86.9926C507.782 87.0738 507.917 87.128 508.025 87.1821C508.133 87.2363 508.296 87.2633 508.431 87.2904C508.566 87.3175 508.701 87.3175 508.836 87.3175C508.972 87.3175 509.107 87.3175 509.242 87.2904C509.377 87.2633 509.513 87.2363 509.648 87.1821C509.783 87.128 509.891 87.0738 509.999 86.9926C510.108 86.9114 510.216 86.8302 510.324 86.7219C510.432 86.6136 510.513 86.5053 510.595 86.397C510.676 86.2887 510.73 86.1533 510.784 86.045C510.838 85.9367 510.892 85.7743 510.892 85.6389C510.892 85.5036 510.919 85.3682 510.919 85.2328C510.919 85.0704 510.919 84.935 510.865 84.7726C510.811 84.6101 510.784 84.4748 510.73 84.3394C510.676 84.204 510.595 84.0687 510.513 83.9604C510.432 83.8521 510.324 83.7438 510.216 83.6355C510.162 83.5814 510.081 83.5001 510.027 83.446C509.972 83.3918 509.918 83.2835 509.891 83.2023C509.864 83.1211 509.837 83.0399 509.81 82.9587C509.783 82.8774 509.81 82.7692 509.783 82.6879V81.9028V78.3291",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.274 84.2852H510.73",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.274 86.1807H510.73",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.508 84.2852H506.97",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.508 86.1807H506.97",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.299 84.2854V80.7658C512.056 80.6034 511.785 80.4139 511.515 80.2785C511.244 80.1431 510.974 80.0078 510.676 79.9265C510.379 79.8453 510.108 79.7912 509.838 79.71",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.402 84.2854C505.402 84.2854 505.402 84.15 505.402 84.0688C505.402 83.8793 505.402 83.6898 505.402 83.5002C505.402 83.3107 505.402 83.1483 505.402 82.9858C505.402 82.8234 505.402 82.661 505.402 82.4985C505.402 82.3361 505.402 82.2007 505.402 82.0653C505.402 81.93 505.402 81.7946 505.402 81.6863C505.402 81.578 505.402 81.4697 505.402 81.3614C505.402 81.2531 505.402 81.1719 505.402 81.0907C505.402 81.0095 505.402 80.9553 505.402 80.9012C505.402 80.847 505.402 80.82 505.402 80.7929C505.402 80.7658 505.402 80.7658 505.402 80.7658C505.646 80.6034 505.916 80.4139 506.187 80.2785C506.457 80.1431 506.728 80.0078 507.025 79.9265C507.323 79.8453 507.593 79.7912 507.864 79.71",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.402 89.6734C505.402 89.6734 505.402 89.6734 505.402 89.6463C505.402 89.6193 505.402 89.5922 505.402 89.538C505.402 89.4839 505.402 89.4297 505.402 89.3485C505.402 89.2673 505.402 89.1861 505.402 89.1049C505.402 89.0236 505.402 88.8883 505.402 88.78C505.402 88.6717 505.402 88.5363 505.402 88.401C505.402 88.2656 505.402 88.1302 505.402 87.9678C505.402 87.8053 505.402 87.6429 505.402 87.4805C505.402 87.318 505.402 87.1285 505.402 86.9661C505.402 86.8036 505.402 86.6141 505.402 86.4246C505.402 86.3704 505.402 86.2892 505.402 86.2351C505.402 86.3163 505.402 86.3704 505.402 86.4517C505.402 86.6412 505.402 86.8307 505.402 87.0202C505.402 87.2097 505.402 87.3722 505.402 87.5346C505.402 87.6971 505.402 87.8595 505.402 88.0219C505.402 88.1844 505.402 88.3197 505.402 88.4551C505.402 88.5905 505.402 88.7258 505.402 88.8341C505.402 88.9424 505.402 89.0507 505.402 89.159C505.402 89.2673 505.402 89.3485 505.402 89.4297C505.402 89.511 505.402 89.5651 505.402 89.6193C505.402 89.6734 505.402 89.7005 505.402 89.7276C505.402 89.7546 505.402 89.7546 505.402 89.7546C505.646 89.9171 505.916 90.1066 506.187 90.242C506.457 90.3773 506.728 90.5127 507.025 90.5939C507.323 90.6751 507.62 90.7564 507.918 90.8105C508.215 90.8646 508.513 90.8917 508.837 90.8917C509.162 90.8917 509.432 90.8917 509.757 90.8105C510.081 90.7293 510.352 90.7022 510.649 90.5939C510.947 90.4856 511.217 90.3773 511.488 90.242C511.758 90.1066 512.002 89.9171 512.272 89.7546V86.4246C512.272 86.4246 512.272 86.2892 512.272 86.208",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.867 84.2857V82.9591C513.759 82.7425 513.651 82.4989 513.516 82.2823C513.38 82.0657 513.245 81.8491 513.083 81.6596C512.975 81.4971 512.839 81.3618 512.704 81.2264C512.569 81.091 512.434 80.9557 512.271 80.8203",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 515.273,
    cy: 84.34,
    rx: 0.378648,
    ry: 0.379029,
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.833 87.3445H502.562L502.508 87.2904V83.1752L502.562 83.1211H503.833",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.867 87.3445H515.22L515.274 87.2904V83.4189V83.1752L515.22 83.1211H513.867",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.946 76.7861H506.727V78.3293H510.946V76.7861Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.21 66.6059C501.21 66.6059 501.156 66.7683 501.129 66.8496C501.102 66.9308 501.075 67.012 501.075 67.0932C501.075 67.1744 501.048 67.2557 501.021 67.3369C500.994 67.4181 500.994 67.4993 500.966 67.5805C500.966 67.6618 500.966 67.7701 500.939 67.8513V73.5638C500.939 73.5638 500.939 73.7533 500.966 73.8345C500.966 73.9157 500.994 73.997 501.021 74.0782C501.048 74.1594 501.048 74.2406 501.075 74.3218C501.102 74.4031 501.129 74.4843 501.129 74.5655C501.129 74.6467 501.183 74.7279 501.21 74.8092H501.318H501.751H516.437C516.491 74.6738 516.518 74.5384 516.572 74.4031C516.626 74.2677 516.653 74.1323 516.653 73.9699C516.653 73.8074 516.707 73.6721 516.707 73.5367V67.8242C516.707 67.6888 516.68 67.5264 516.653 67.391C516.626 67.2557 516.599 67.0932 516.572 66.9579C516.545 66.8225 516.491 66.6871 516.437 66.5518",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.451 61.6252L499.641 57.9703V57.862C499.641 57.862 499.695 57.4288 500.479 57.4017C500.479 57.4017 503.833 56.752 509.296 56.752H509.999C514.489 56.8873 517.167 57.4017 517.167 57.4017C517.951 57.4017 518.005 57.862 518.005 57.862V57.9703L518.194 61.571",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.141 29.2988V30.3547",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.018 29.2988H481.141",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.018 29.2988V30.3547",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.018 30.3545H481.141",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 155.95V155.895",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 155.894L519.627 155.461",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 155.109V155.461",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 155.109L520.817 154.676",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 154.676V154.216",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 154.215L519.627 153.782",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 153.458V153.783",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 153.458L520.817 153.024",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 153.025V152.564",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 152.564L519.627 152.131",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 151.807V152.132",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 151.806L520.817 151.373",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 151.373V150.913",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 150.913L519.627 150.479",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 150.128V150.48",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 150.128L520.817 149.722",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 149.722V149.262",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 149.261L519.627 148.828",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 148.477V148.829",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 148.476L520.817 148.043",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 148.044V147.61",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 147.61L519.627 147.177",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 146.825V147.177",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 146.825L520.817 146.392",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 146.392V145.932",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 145.931L519.627 145.498",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 145.173V145.498",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 145.173L520.817 144.74",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 144.741V144.28",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 144.28L519.627 143.847",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 143.521V143.846",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 143.522L520.817 143.089",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 143.088V142.628",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 142.628L519.627 142.195",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 141.843V142.195",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 141.843L520.817 141.41",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 141.41V140.977",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 140.977L519.627 140.544",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 140.191V140.543",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 140.192L520.817 139.759",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 139.758V139.298",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 139.298L519.627 138.865",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 138.54V138.865",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 138.541L520.817 138.107",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 138.107V137.646",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 137.647L519.627 137.214",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 136.889V137.214",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 136.889L520.817 136.456",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 136.455V135.995",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 135.996L519.627 135.562",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 135.21V135.562",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 135.211L520.817 134.777",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 134.777V134.344",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 134.344L519.627 133.911",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 133.559V133.911",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 133.559L520.817 133.126",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 133.125V132.665",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 132.666L519.627 132.232",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 131.907V132.232",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 131.907L520.817 131.474",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 131.474V131.014",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 131.014L519.627 130.581",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 130.256V130.581",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 130.255L520.817 129.822",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 129.823V129.362",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 129.362L519.627 128.929",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 128.577V128.929",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 128.578L520.817 128.145",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 128.144V127.711",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 127.711L519.627 127.277",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 126.926V127.278",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 126.925L520.817 126.492",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 126.492V126.032",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 126.032L519.627 125.626",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 125.274V125.626",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 125.274L520.817 124.841",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 124.841V124.381",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 124.381L520.574 124.3",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.141 115.853L519.627 115.663",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 115.338V115.663",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 115.338L520.817 114.905",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 114.906V114.445",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 114.445L519.627 114.012",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 113.66V114.012",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 113.66L520.817 113.227",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 113.226V112.793",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 112.794L519.627 112.36",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 112.008V112.36",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 112.008L520.817 111.575",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 111.575V111.115",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 111.115L519.627 110.682",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 110.356V110.681",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 110.357L520.817 109.924",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 109.923V109.463",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 109.463L519.627 109.03",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 108.705V109.03",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 108.706L520.817 108.272",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 108.272V107.812",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 107.812L519.627 107.379",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 107.026V107.378",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 107.027L520.817 106.594",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 106.593V106.16",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 106.161L519.627 105.728",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 105.375V105.727",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 105.376L520.817 104.942",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 104.942V104.481",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 104.482L519.627 104.049",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 103.724V104.049",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 103.724L520.817 103.291",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 103.29V102.83",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 102.831L519.627 102.397",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 102.072V102.397",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 102.072L520.817 101.639",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 101.639V101.179",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 101.179L519.627 100.746",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 100.394V100.746",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 100.393L520.817 99.9873",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 99.9876V99.5273",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 99.5269L519.627 99.0938",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 98.7422V99.0941",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 98.7427L520.817 98.3096",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 98.3089V97.8486",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 97.8485L519.627 97.4424",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 97.0908V97.4428",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 97.0904L520.817 96.6572",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 96.6575V96.1973",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 96.1978L519.627 95.7646",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 95.4395V95.7643",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 95.439L520.817 95.0059",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 95.0062V94.5459",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 94.5455L519.627 94.1123",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 93.7881V94.113",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 93.7877L520.817 93.3545",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 93.3548V92.8945",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 92.8941L519.627 92.4609",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 92.1094V92.4613",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 92.109L520.817 91.6758",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 91.6763V91.2432",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 91.2427L519.627 90.8096",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 90.458V90.81",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 90.4576L520.817 90.0244",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 90.0247V89.5645",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 89.564L519.627 89.1309",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 88.8066V89.1315",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 88.8062L520.817 88.373",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 88.3733V87.9131",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 87.9127L519.627 87.4795",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 87.1553V87.4802",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 87.1549L520.817 86.7217",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 86.722V86.2617",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 86.2613L519.627 85.8281",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 85.4766V85.8285",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 85.4761L520.817 85.043",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 85.0435V84.6104",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 84.6102L519.682 84.2041",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 75.54V75.7566",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 75.5406L520.817 75.1074",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 75.1067V74.6465",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 74.647L519.627 74.2139",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 73.8887V74.2136",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 73.8892L520.817 73.4561",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 73.4554V72.9951",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 72.9957L519.627 72.5625",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 72.21V72.5619",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 72.2098L520.817 71.8037",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 71.804V71.3438",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 71.3443L519.627 70.9111",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 70.5586V70.9106",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 70.5592L520.817 70.126",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 70.1256V69.6924",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 69.692L519.627 69.2588",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 68.9072V69.2592",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 68.9078L520.817 68.4746",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 68.4739V68.0137",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 68.0142L519.627 67.5811",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 67.2559V67.5807",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 67.2554L520.817 66.8223",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 66.8226V66.3623",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 66.3629L519.627 65.9297",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 65.6045V65.9294",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 65.6041L520.817 65.1709",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 65.1712V64.7109",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 64.7105L519.627 64.2773",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 63.9258V64.2777",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 63.9254L520.817 63.4922",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 63.4927V63.0596",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 63.0592L519.627 62.626",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 62.2744V62.6264",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 62.274L520.817 61.8408",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 61.8411V61.3809",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 61.3804L519.627 60.9473",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 60.623V60.9479",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 60.6226L520.817 60.1895",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 60.1897V59.7295",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 59.7291L519.627 59.2959",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 58.9717V59.2966",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 58.9713L520.817 58.5381",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 58.5384V58.0781",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 58.0777L519.627 57.6445",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 57.293V57.6449",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 57.2926L520.817 56.8594",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 56.8599V56.4268",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 56.4263L519.627 55.9932",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 55.6416V55.9936",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 55.6412L520.817 55.208",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 55.2083V54.748",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 54.7476L519.627 54.3145",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 53.9902V54.3151",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 53.9898L520.817 53.5566",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 53.5569V53.0967",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 53.0963L519.627 52.6631",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 52.3379V52.6628",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 52.3384L520.817 51.9053",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 51.9056V51.4453",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 51.4449L519.627 51.0117",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 50.6602V51.0121",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 50.6597L520.817 50.2266",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 50.2261V49.793",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 49.7935L519.627 49.3604",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 49.0088V49.3607",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 49.0084L520.817 48.5752",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 48.5755V48.1152",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 48.1151L519.627 47.709",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 47.3564V47.7084",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 47.357L520.817 46.9238",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 46.9241V46.4639",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 46.4634L519.627 46.0303",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 45.7051V46.03",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 45.7056L520.817 45.2725",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 45.2718V44.8115",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 44.8121L519.627 44.3789",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 44.0811V44.3789",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.926 35.6345L520.818 35.3096",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 35.3092V34.876",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 34.8756L519.627 34.4424",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 34.0908V34.4428",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 34.0904L520.817 33.6572",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 33.6575V33.1973",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 33.1978L519.627 32.7646",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 32.4395V32.7643",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 32.439L520.817 32.0059",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.818 32.0061V31.5459",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.817 31.5455L519.627 31.1123",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 30.7881V31.113",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.627 30.7877L520.763 30.3545",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.98 30.3545V164.395",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.088 164.395V30.3545",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.072 164.395V30.3545",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.773 150.154H535.828",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.178 150.154H534.286",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.287 150.154H534.585",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.639 150.154H535.774",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.584 150.154H535.639",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.584 150.154H534.963",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.396 150.154H535.586",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.828 150.154H536.017",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.072 150.155V31.9521",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.018 150.154H536.073",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.018 31.9521H536.073",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.26 150.154H535.395",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.963 150.154H535.26",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.574 150.154H483.872",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.195 150.154H483.574",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.873 150.154H483.981",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.385 150.154H482.52",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.33 150.154H482.385",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.52 150.154H482.575",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.574 150.154H482.764",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.141 150.154H482.33",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.088 150.155V31.9521",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.088 150.154H482.143",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.764 150.154H482.899",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.898 150.154H483.196",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.34 155.948V30.3545",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.771 30.3545H533.151",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.553 30.3545H530.69",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.902 155.949V124.3",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.902 115.853V84.2041",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.902 75.757V44.0811",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.902 35.6338V30.3545",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.064 30.3545H526.471",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.689 30.3545H493.096",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.258 155.949V124.3",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.258 115.853V84.2041",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.258 75.757V44.0811",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.258 35.6338V30.3545",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.469 30.3545H490.606",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.818 155.948V30.3545",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.008 30.3545H486.387",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.09 84.2038V75.7568",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.07 75.7568H485.09",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.07 84.2038V75.7568",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.07 84.2041H485.09",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.09 44.0807V35.6338",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.07 35.6338H485.09",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.07 44.0807V35.6338",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.07 44.0811H485.09",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.09 124.299V115.853",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.07 115.853H485.09",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.07 124.299V115.853",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.07 124.3H485.09",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.34 166.507V155.948",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.339 155.948H484.818",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.818 166.507V155.948",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.871 164.396V166.507",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.288 164.396H533.34",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.819 164.396H481.871",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.288 166.507H533.34",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.819 166.507H481.871",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.289 164.396V166.507",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.033 128.875H445.304",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.033 128.875V125.491",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.305 128.875V125.491",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.033 97.5244H445.304",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.305 125.491V97.5244",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.033 125.491V97.5244",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.033 125.491H445.304",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.873 124.219V123.84V122.053V121.674",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.602 125.166H447.657",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.385 124.949L445.601 125.166",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.385 120.942V124.949",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.601 120.726L445.385 120.942",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.657 120.726H445.602",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.875 120.942L447.658 120.726",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.658 125.166L447.875 124.949",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.873 121.673V120.942",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.873 124.95V124.219",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.469 117.478H445.305",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.469 118.723H445.305",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.038 127.169H445.305",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.528 128.441H445.305",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.527 127.711V128.442",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.881 100.177V101.558",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.305 100.177V101.558",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.305 97.6865V99.0943",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.881 97.6865V99.0943",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.882 101.747H530.176",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.737 101.747H516.977",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.182 101.747H496.232",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.794 101.747H445.305",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.882 97.5244H530.176",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.737 97.5244H516.977",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.182 97.5244H496.232",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.794 97.5244H445.305",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.125 128.875V125.491",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.125 128.875H572.881",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.881 128.875V125.491",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.125 97.5244H572.881",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.125 125.491V97.5244",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.125 125.491H572.881",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.881 125.491V97.5244",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.285 124.219V123.84V122.053V121.674",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.285 120.942L570.502 120.726",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.502 120.726H572.585",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.584 120.726L572.773 120.942",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.585 125.166H570.502",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.502 125.166L570.285 124.949",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.773 124.949L572.584 125.166",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.773 120.942V124.949",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.285 121.673V120.942",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.285 124.95V124.219",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.717 117.478H572.881",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.717 118.723H572.881",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.631 127.711V128.442",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.121 127.169H572.881",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.631 128.441H572.881",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.037 113.145V111.656",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.121 113.145V111.656",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.037 111.656V111.575",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.121 111.656V111.575",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.037 113.227V113.146",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.121 113.227V113.146",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.037 111.575V111.386",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.121 111.575V111.386",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.037 113.389V113.227",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.121 113.389V113.227",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.037 113.443H487.794",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.156 113.443H505.4",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.176 113.443H568.122",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.037 113.444V113.389",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.121 113.444V113.389",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.037 111.331H487.794",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.156 111.331H505.4",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.176 111.331H568.122",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.037 111.386V111.331",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.121 111.386V111.331",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.453 151.969H537.344",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.453 150.913V151.969",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.344 151.969V150.913",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.344 127.711H539.453",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.453 127.711V128.767",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.344 128.767V127.711",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.453 150.913V128.767",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.344 150.913V128.767",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.727 127.711V151.969",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.727 151.969H539.453",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.727 127.711H539.453",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.707 128.767V150.913",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.816 128.767V150.913",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.817 151.969H478.707",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.707 151.969V150.913",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.816 150.913V151.969",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.707 127.711H480.817",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.707 128.767V127.711",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.816 127.711V128.767",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.432 151.969V127.711",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.432 127.711H478.706",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.432 151.969H478.706",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.717 104.481V102.911",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.469 102.911H569.717",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.717 125.599V104.481",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.607 127.711L569.717 125.6",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.727 127.711H567.608",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.816 151.969H537.343",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.578 127.711H473.432",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.469 125.6L450.578 127.711",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.469 104.481V125.599",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.237 106.377H461.1",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.1 106.377C460.802 106.377 460.586 106.621 460.586 106.891",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.586 106.919V108.164",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.1 108.705H502.237",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.061 118.425C557.358 118.425 557.574 118.181 557.574 117.91",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.574 116.611C557.574 116.313 557.331 116.097 557.061 116.097",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.06 116.097H530.176",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.186 118.316C507.186 118.316 507.375 118.425 507.51 118.425",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.534 106.485C502.534 106.485 502.344 106.377 502.209 106.377",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.512 118.425H557.061",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.586 108.164C460.586 108.462 460.829 108.678 461.1 108.678",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.574 117.883V116.61",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.432 151.969V154.08",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.432 154.08H544.726",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.727 151.969V154.08",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.175 101.747H521.736",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.977 101.747H501.182",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.233 101.747H487.795",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.175 97.5244H521.736",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.977 97.5244H501.182",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.233 97.5244H487.795",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.971 116.61V117.883",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.795 113.443H504.158",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.4 113.443H530.175",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.795 111.331H504.158",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.4 111.331H530.175",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.236 108.705C502.534 108.705 502.75 108.461 502.75 108.19",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.75 108.164V106.919",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.176 116.097H507.512",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.51 116.097C507.212 116.097 506.996 116.34 506.996 116.611",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.971 117.883C506.971 118.045 507.052 118.208 507.187 118.316",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.752 106.919C502.752 106.756 502.67 106.594 502.535 106.485",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.19 74.4033H467.969",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.189 74.4033V80.7385",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.135 81.7941C549.73 81.7941 550.19 81.3339 550.19 80.7383",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.135 81.7939H516.977",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.181 81.7939H469.023",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.969 80.7383C467.969 81.3339 468.429 81.7941 469.024 81.7941",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.969 74.4033V80.7385",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.182 106.377H516.977",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.182 74.7285V106.377",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.977 74.7285H501.182",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.977 106.377V74.7285",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.469 104.481V102.911",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.003 147.393C517.048 147.393 517.896 146.544 517.896 145.498C517.896 144.451 517.048 143.603 516.003 143.603C514.957 143.603 514.109 144.451 514.109 145.498C514.109 146.544 514.957 147.393 516.003 147.393Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.352 142.546C514.19 142.628 514.028 142.736 513.893 142.871C513.622 142.519 513.243 142.276 512.784 142.221C512.73 142.276 512.676 142.33 512.621 142.411C512.703 142.844 512.946 143.223 513.298 143.494C513.189 143.656 513.081 143.819 513 143.981C512.621 143.765 512.162 143.71 511.729 143.846C511.702 143.927 511.675 144.008 511.648 144.089C511.891 144.469 512.27 144.712 512.703 144.793C512.648 144.983 512.648 145.172 512.621 145.362C512.189 145.308 511.756 145.47 511.404 145.741C511.404 145.822 511.404 145.903 511.404 145.985C511.783 146.228 512.216 146.309 512.648 146.201C512.675 146.391 512.73 146.58 512.811 146.743C512.405 146.878 512.053 147.176 511.864 147.582C511.891 147.663 511.945 147.717 511.972 147.799C512.405 147.853 512.865 147.744 513.189 147.474C513.298 147.636 513.433 147.771 513.541 147.907C513.216 148.205 513.027 148.611 513.027 149.071C513.081 149.125 513.162 149.179 513.216 149.233C513.649 149.125 514.001 148.827 514.217 148.448C514.379 148.557 514.542 148.638 514.731 148.692C514.542 149.098 514.542 149.558 514.731 149.964L514.974 150.019C515.326 149.748 515.515 149.342 515.569 148.881C515.759 148.881 515.948 148.909 516.137 148.881C516.137 149.315 516.327 149.748 516.651 150.046L516.895 149.991C517.084 149.585 517.111 149.125 516.976 148.719C517.165 148.665 517.327 148.584 517.49 148.502C517.679 148.909 518.004 149.206 518.436 149.369C518.517 149.315 518.572 149.288 518.653 149.233C518.653 148.8 518.517 148.367 518.22 148.042C518.355 147.907 518.49 147.771 518.599 147.636C518.923 147.934 519.356 148.069 519.816 148.042C519.87 147.961 519.897 147.907 519.951 147.826C519.789 147.42 519.464 147.095 519.058 146.932C519.14 146.77 519.194 146.58 519.248 146.391C519.68 146.526 520.113 146.472 520.519 146.255V146.012C520.248 145.714 519.816 145.524 519.383 145.551C519.383 145.362 519.383 145.172 519.356 144.983C519.789 144.929 520.194 144.712 520.465 144.36L520.384 144.117C519.978 143.954 519.518 143.981 519.113 144.171C519.031 144.008 518.95 143.819 518.842 143.683C519.221 143.467 519.491 143.088 519.599 142.655C519.545 142.6 519.491 142.519 519.437 142.465C519.004 142.465 518.599 142.709 518.301 143.034C518.166 142.898 518.004 142.79 517.868 142.682C518.112 142.33 518.22 141.869 518.139 141.436C518.058 141.409 518.004 141.355 517.922 141.328C517.544 141.517 517.246 141.897 517.111 142.303C516.922 142.248 516.759 142.194 516.57 142.167C516.651 141.734 516.57 141.274 516.327 140.922C516.246 140.922 516.164 140.922 516.083 140.922C515.813 141.274 515.678 141.707 515.732 142.14C515.542 142.14 515.353 142.194 515.164 142.248C515.056 141.815 514.812 141.436 514.434 141.22C514.352 141.247 514.271 141.274 514.217 141.301C514.109 141.734 514.163 142.194 514.406 142.546H514.352Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 146.418C516.51 146.418 516.921 146.006 516.921 145.498C516.921 144.989 516.51 144.577 516.002 144.577C515.494 144.577 515.082 144.989 515.082 145.498C515.082 146.006 515.494 146.418 516.002 146.418Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 519.465,
    cy: 144.956,
    rx: 0.378648,
    ry: 0.379029,
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 519.517,
    cy: 145.525,
    rx: 0.378648,
    ry: 0.379029,
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.602 7.125V304.744",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.629 7.125V304.744",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.602 205.601H683.501",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.203 293.969H585.431",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.667 298.219L260.957 293.942L271.667 289.664V298.219Z",
    fill: "#2360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.699 289.691L592.41 293.969L581.699 298.247V289.691Z",
    fill: "#2360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 281H387V306H476V281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.309 36.1748V194.636",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.035 41.6439L641.308 30.9229L645.582 41.6439H637.035Z",
    fill: "#2360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.554 190.9L641.281 201.621L637.008 190.9H645.554Z",
    fill: "#2360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.705 302.239C405.58 302.239 404.577 302.045 403.696 301.659C402.821 301.273 402.125 300.736 401.608 300.048C401.097 299.355 400.818 298.551 400.773 297.636H402.92C402.966 298.199 403.159 298.685 403.5 299.094C403.841 299.497 404.287 299.81 404.838 300.031C405.389 300.253 406 300.364 406.67 300.364C407.42 300.364 408.085 300.233 408.665 299.972C409.244 299.71 409.699 299.347 410.028 298.881C410.358 298.415 410.523 297.875 410.523 297.261C410.523 296.619 410.364 296.054 410.045 295.565C409.727 295.071 409.261 294.685 408.648 294.406C408.034 294.128 407.284 293.989 406.398 293.989H405V292.114H406.398C407.091 292.114 407.699 291.989 408.222 291.739C408.75 291.489 409.162 291.136 409.457 290.682C409.759 290.227 409.909 289.693 409.909 289.08C409.909 288.489 409.778 287.974 409.517 287.537C409.256 287.099 408.886 286.759 408.409 286.514C407.938 286.27 407.381 286.148 406.739 286.148C406.136 286.148 405.568 286.259 405.034 286.48C404.506 286.696 404.074 287.011 403.739 287.426C403.403 287.835 403.222 288.33 403.193 288.909H401.148C401.182 287.994 401.457 287.193 401.974 286.506C402.491 285.812 403.168 285.273 404.003 284.886C404.844 284.5 405.767 284.307 406.773 284.307C407.852 284.307 408.778 284.526 409.551 284.963C410.324 285.395 410.918 285.966 411.332 286.676C411.747 287.386 411.955 288.153 411.955 288.977C411.955 289.96 411.696 290.798 411.179 291.491C410.668 292.185 409.972 292.665 409.091 292.932V293.068C410.193 293.25 411.054 293.719 411.673 294.474C412.293 295.224 412.602 296.153 412.602 297.261C412.602 298.21 412.344 299.062 411.827 299.818C411.315 300.568 410.616 301.159 409.73 301.591C408.844 302.023 407.835 302.239 406.705 302.239ZM418.583 299.614L418.447 300.534C418.35 301.182 418.202 301.875 418.004 302.614C417.81 303.352 417.609 304.048 417.398 304.702C417.188 305.355 417.015 305.875 416.879 306.261H415.344C415.418 305.898 415.515 305.418 415.634 304.821C415.754 304.224 415.873 303.557 415.992 302.818C416.117 302.085 416.219 301.335 416.299 300.568L416.401 299.614H418.583ZM422.276 302V300.466L428.037 294.159C428.713 293.42 429.27 292.778 429.707 292.233C430.145 291.682 430.469 291.165 430.679 290.682C430.895 290.193 431.003 289.682 431.003 289.148C431.003 288.534 430.855 288.003 430.56 287.554C430.27 287.105 429.872 286.759 429.366 286.514C428.861 286.27 428.293 286.148 427.662 286.148C426.991 286.148 426.406 286.287 425.906 286.565C425.412 286.838 425.028 287.222 424.756 287.716C424.489 288.21 424.355 288.79 424.355 289.455H422.344C422.344 288.432 422.58 287.534 423.051 286.761C423.523 285.989 424.165 285.386 424.977 284.955C425.795 284.523 426.713 284.307 427.73 284.307C428.753 284.307 429.659 284.523 430.449 284.955C431.239 285.386 431.858 285.969 432.307 286.702C432.756 287.435 432.98 288.25 432.98 289.148C432.98 289.79 432.864 290.418 432.631 291.031C432.403 291.639 432.006 292.318 431.438 293.068C430.875 293.812 430.094 294.722 429.094 295.795L425.173 299.989V300.125H433.287V302H422.276ZM442.5 302.239C441.216 302.239 440.122 301.889 439.219 301.19C438.315 300.486 437.625 299.466 437.148 298.131C436.67 296.79 436.432 295.17 436.432 293.273C436.432 291.386 436.67 289.776 437.148 288.44C437.631 287.099 438.324 286.077 439.227 285.372C440.136 284.662 441.227 284.307 442.5 284.307C443.773 284.307 444.861 284.662 445.764 285.372C446.673 286.077 447.366 287.099 447.844 288.44C448.327 289.776 448.568 291.386 448.568 293.273C448.568 295.17 448.33 296.79 447.852 298.131C447.375 299.466 446.685 300.486 445.781 301.19C444.878 301.889 443.784 302.239 442.5 302.239ZM442.5 300.364C443.773 300.364 444.761 299.75 445.466 298.523C446.17 297.295 446.523 295.545 446.523 293.273C446.523 291.761 446.361 290.474 446.037 289.412C445.719 288.349 445.259 287.54 444.656 286.983C444.06 286.426 443.341 286.148 442.5 286.148C441.239 286.148 440.253 286.77 439.543 288.014C438.832 289.253 438.477 291.006 438.477 293.273C438.477 294.784 438.636 296.068 438.955 297.125C439.273 298.182 439.73 298.986 440.327 299.537C440.929 300.088 441.653 300.364 442.5 300.364ZM457.5 302.239C456.216 302.239 455.122 301.889 454.219 301.19C453.315 300.486 452.625 299.466 452.148 298.131C451.67 296.79 451.432 295.17 451.432 293.273C451.432 291.386 451.67 289.776 452.148 288.44C452.631 287.099 453.324 286.077 454.227 285.372C455.136 284.662 456.227 284.307 457.5 284.307C458.773 284.307 459.861 284.662 460.764 285.372C461.673 286.077 462.366 287.099 462.844 288.44C463.327 289.776 463.568 291.386 463.568 293.273C463.568 295.17 463.33 296.79 462.852 298.131C462.375 299.466 461.685 300.486 460.781 301.19C459.878 301.889 458.784 302.239 457.5 302.239ZM457.5 300.364C458.773 300.364 459.761 299.75 460.466 298.523C461.17 297.295 461.523 295.545 461.523 293.273C461.523 291.761 461.361 290.474 461.037 289.412C460.719 288.349 460.259 287.54 459.656 286.983C459.06 286.426 458.341 286.148 457.5 286.148C456.239 286.148 455.253 286.77 454.543 288.014C453.832 289.253 453.477 291.006 453.477 293.273C453.477 294.784 453.636 296.068 453.955 297.125C454.273 298.182 454.73 298.986 455.327 299.537C455.929 300.088 456.653 300.364 457.5 300.364Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.6 16.9521V194.635",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.354 22.4213L670.627 11.7002L674.9 22.4213H666.354Z",
    fill: "#2360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.873 190.899L670.599 201.621L666.326 190.899H674.873Z",
    fill: "#2360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.602 9.39941H683.501",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.602 27.917H653.155",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.256 150.588V76.623H659.322V150.588H680.256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.455 88.9432H662V86.8295H677.239V86.7273L674.409 82.4659H676.557L679.455 86.8295V88.9432ZM664.386 95.9659L663.466 95.8295C662.818 95.733 662.125 95.5852 661.386 95.3864C660.648 95.1932 659.952 94.9915 659.298 94.7812C658.645 94.571 658.125 94.3977 657.739 94.2614V92.7273C658.102 92.8011 658.582 92.8977 659.179 93.017C659.776 93.1364 660.443 93.2557 661.182 93.375C661.915 93.5 662.665 93.6023 663.432 93.6818L664.386 93.7841V95.9659ZM679.693 105.051C679.688 105.767 679.551 106.483 679.284 107.199C679.017 107.915 678.574 108.568 677.955 109.159C677.341 109.75 676.503 110.224 675.44 110.582C674.378 110.94 673.045 111.119 671.443 111.119C669.892 111.119 668.514 110.972 667.31 110.676C666.111 110.386 665.099 109.966 664.276 109.415C663.452 108.869 662.827 108.205 662.401 107.42C661.974 106.642 661.761 105.761 661.761 104.778C661.761 103.801 661.955 102.929 662.341 102.162C662.733 101.401 663.276 100.776 663.969 100.287C664.668 99.804 665.477 99.4943 666.398 99.358V101.438C665.597 101.625 664.935 101.997 664.412 102.554C663.895 103.116 663.636 103.858 663.636 104.778C663.636 106.125 664.224 107.188 665.401 107.966C666.577 108.75 668.239 109.142 670.386 109.142V109.006C669.909 108.688 669.497 108.31 669.151 107.872C668.804 107.435 668.537 106.949 668.349 106.415C668.162 105.881 668.068 105.313 668.068 104.71C668.068 103.71 668.315 102.793 668.81 101.957C669.31 101.128 669.994 100.463 670.864 99.9631C671.739 99.4688 672.739 99.2216 673.864 99.2216C674.932 99.2216 675.909 99.4602 676.795 99.9375C677.688 100.42 678.398 101.097 678.926 101.966C679.455 102.841 679.71 103.869 679.693 105.051ZM677.818 105.051C677.818 104.335 677.639 103.69 677.281 103.116C676.929 102.548 676.452 102.097 675.849 101.761C675.253 101.432 674.591 101.267 673.864 101.267C673.136 101.267 672.474 101.426 671.878 101.744C671.287 102.068 670.815 102.509 670.463 103.065C670.116 103.628 669.943 104.267 669.943 104.983C669.943 105.523 670.048 106.026 670.259 106.491C670.474 106.957 670.767 107.364 671.136 107.71C671.511 108.063 671.935 108.338 672.406 108.537C672.884 108.736 673.381 108.835 673.898 108.835C674.58 108.835 675.219 108.67 675.815 108.341C676.412 108.017 676.895 107.568 677.264 106.994C677.634 106.426 677.818 105.778 677.818 105.051ZM661.761 120.164C661.761 118.88 662.111 117.786 662.81 116.883C663.514 115.979 664.534 115.289 665.869 114.812C667.21 114.335 668.83 114.096 670.727 114.096C672.614 114.096 674.224 114.335 675.56 114.812C676.901 115.295 677.923 115.988 678.628 116.891C679.338 117.8 679.693 118.891 679.693 120.164C679.693 121.437 679.338 122.525 678.628 123.428C677.923 124.337 676.901 125.031 675.56 125.508C674.224 125.991 672.614 126.232 670.727 126.232C668.83 126.232 667.21 125.994 665.869 125.516C664.534 125.039 663.514 124.349 662.81 123.445C662.111 122.542 661.761 121.448 661.761 120.164ZM663.636 120.164C663.636 121.437 664.25 122.425 665.477 123.13C666.705 123.835 668.455 124.187 670.727 124.187C672.239 124.187 673.526 124.025 674.588 123.701C675.651 123.383 676.46 122.923 677.017 122.32C677.574 121.724 677.852 121.005 677.852 120.164C677.852 118.903 677.23 117.917 675.986 117.207C674.747 116.496 672.994 116.141 670.727 116.141C669.216 116.141 667.932 116.3 666.875 116.619C665.818 116.937 665.014 117.394 664.463 117.991C663.912 118.593 663.636 119.317 663.636 120.164ZM661.761 135.164C661.761 133.88 662.111 132.786 662.81 131.883C663.514 130.979 664.534 130.289 665.869 129.812C667.21 129.335 668.83 129.096 670.727 129.096C672.614 129.096 674.224 129.335 675.56 129.812C676.901 130.295 677.923 130.988 678.628 131.891C679.338 132.8 679.693 133.891 679.693 135.164C679.693 136.437 679.338 137.525 678.628 138.428C677.923 139.337 676.901 140.031 675.56 140.508C674.224 140.991 672.614 141.232 670.727 141.232C668.83 141.232 667.21 140.994 665.869 140.516C664.534 140.039 663.514 139.349 662.81 138.445C662.111 137.542 661.761 136.448 661.761 135.164ZM663.636 135.164C663.636 136.437 664.25 137.425 665.477 138.13C666.705 138.835 668.455 139.187 670.727 139.187C672.239 139.187 673.526 139.025 674.588 138.701C675.651 138.383 676.46 137.923 677.017 137.32C677.574 136.724 677.852 136.005 677.852 135.164C677.852 133.903 677.23 132.917 675.986 132.207C674.747 131.496 672.994 131.141 670.727 131.141C669.216 131.141 667.932 131.3 666.875 131.619C665.818 131.937 665.014 132.394 664.463 132.991C663.912 133.593 663.636 134.317 663.636 135.164Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.938 150.588V76.623H630.004V150.588H650.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.455 92.9432H631V90.8295H646.239V90.7273L643.409 86.4659H645.557L648.455 90.8295V92.9432ZM633.386 99.9659L632.466 99.8295C631.818 99.733 631.125 99.5852 630.386 99.3864C629.648 99.1932 628.952 98.9915 628.298 98.7812C627.645 98.571 627.125 98.3977 626.739 98.2614V96.7273C627.102 96.8011 627.582 96.8977 628.179 97.017C628.776 97.1364 629.443 97.2557 630.182 97.375C630.915 97.5 631.665 97.6023 632.432 97.6818L633.386 97.7841V99.9659ZM631 103.852L646.443 111.659H646.58V102.659H648.455V113.841H646.477L631 106.068V103.852ZM630.761 122.257C630.761 121.087 630.969 120.053 631.384 119.155C631.804 118.263 632.381 117.567 633.114 117.067C633.852 116.567 634.693 116.32 635.636 116.325C636.375 116.32 637.057 116.464 637.682 116.76C638.313 117.055 638.838 117.459 639.259 117.97C639.685 118.487 639.955 119.064 640.068 119.7H640.17C640.386 118.865 640.855 118.2 641.577 117.706C642.304 117.212 643.131 116.967 644.057 116.973C644.943 116.967 645.736 117.192 646.435 117.646C647.134 118.101 647.685 118.726 648.088 119.521C648.491 120.322 648.693 121.234 648.693 122.257C648.693 123.268 648.491 124.172 648.088 124.967C647.685 125.763 647.134 126.388 646.435 126.842C645.736 127.303 644.943 127.536 644.057 127.541C643.131 127.536 642.304 127.283 641.577 126.783C640.855 126.288 640.386 125.632 640.17 124.814H640.068C639.955 125.445 639.685 126.013 639.259 126.518C638.838 127.024 638.313 127.428 637.682 127.729C637.057 128.03 636.375 128.183 635.636 128.189C634.693 128.183 633.852 127.928 633.114 127.422C632.381 126.922 631.804 126.226 631.384 125.334C630.969 124.447 630.761 123.422 630.761 122.257ZM632.636 122.257C632.636 123.047 632.764 123.729 633.02 124.303C633.276 124.876 633.636 125.32 634.102 125.632C634.568 125.945 635.114 126.104 635.739 126.109C636.398 126.104 636.98 125.933 637.486 125.598C637.991 125.263 638.389 124.805 638.679 124.226C638.969 123.652 639.114 122.996 639.114 122.257C639.114 121.513 638.969 120.848 638.679 120.263C638.389 119.683 637.991 119.226 637.486 118.891C636.98 118.561 636.398 118.399 635.739 118.405C635.114 118.399 634.568 118.55 634.102 118.857C633.636 119.169 633.276 119.615 633.02 120.195C632.764 120.774 632.636 121.462 632.636 122.257ZM640.92 122.257C640.92 122.882 641.045 123.436 641.295 123.919C641.545 124.408 641.895 124.791 642.344 125.07C642.793 125.348 643.318 125.49 643.92 125.496C644.511 125.49 645.026 125.351 645.463 125.078C645.906 124.805 646.247 124.428 646.486 123.945C646.73 123.462 646.852 122.899 646.852 122.257C646.852 121.604 646.73 121.033 646.486 120.544C646.247 120.055 645.906 119.678 645.463 119.411C645.026 119.143 644.511 119.013 643.92 119.018C643.318 119.013 642.793 119.146 642.344 119.419C641.895 119.697 641.545 120.081 641.295 120.57C641.045 121.058 640.92 121.621 640.92 122.257ZM630.761 137.148C630.761 135.864 631.111 134.771 631.81 133.867C632.514 132.964 633.534 132.273 634.869 131.796C636.21 131.319 637.83 131.08 639.727 131.08C641.614 131.08 643.224 131.319 644.56 131.796C645.901 132.279 646.923 132.972 647.628 133.876C648.338 134.785 648.693 135.876 648.693 137.148C648.693 138.421 648.338 139.509 647.628 140.413C646.923 141.322 645.901 142.015 644.56 142.492C643.224 142.975 641.614 143.217 639.727 143.217C637.83 143.217 636.21 142.978 634.869 142.501C633.534 142.023 632.514 141.333 631.81 140.43C631.111 139.526 630.761 138.433 630.761 137.148ZM632.636 137.148C632.636 138.421 633.25 139.41 634.477 140.114C635.705 140.819 637.455 141.171 639.727 141.171C641.239 141.171 642.526 141.009 643.588 140.685C644.651 140.367 645.46 139.907 646.017 139.305C646.574 138.708 646.852 137.989 646.852 137.148C646.852 135.887 646.23 134.901 644.986 134.191C643.747 133.481 641.994 133.126 639.727 133.126C638.216 133.126 636.932 133.285 635.875 133.603C634.818 133.921 634.014 134.379 633.463 134.975C632.912 135.577 632.636 136.302 632.636 137.148Z",
    fill: "#4C4C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6840_15889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 683,
    height: 322.337,
    fill: "white",
    transform: "translate(0.5 0.00488281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroneStationSpec2);
export default __webpack_public_path__ + "static/media/droneStationSpec2.5001ac8539aec4f548f6bd0958e037fe.svg";
export { ForwardRef as ReactComponent };